import { __rest } from 'tslib';
import { SvgIcon, InputAdornment, CircularProgress, Box, TextField as TextField$1, FormHelperText, FormControlLabel, Checkbox, Skeleton, createFilterOptions, ListItem, ListItemText, Autocomplete, MenuItem, ListItemIcon, FormControl, Select as Select$1, Radio, RadioGroup, Typography, Stack, FormGroup, InputLabel, styled, Chip as Chip$1, useTheme as useTheme$1, useMediaQuery, IconButton, ToggleButton, toggleButtonGroupClasses, Divider } from '@mui/material';
import * as React from 'react';
import React__default, { useMemo, useState, useCallback, forwardRef, useEffect, useLayoutEffect, lazy, useRef, Suspense } from 'react';
import { makeG2STyles, useTheme } from '@komune-io/g2-themes';
import { CheckRounded, ClearRounded, KeyboardArrowDownRounded, FilterAltOutlined, CloseRounded, FormatBoldRounded, FormatItalicRounded, FormatUnderlinedRounded, FormatListBulletedRounded, FormatListNumberedRounded, FormatQuoteRounded, UndoRounded, RedoRounded } from '@mui/icons-material';
import tinycolor from 'tinycolor2';
import { Chip, Actions, Link, Button } from '@komune-io/g2-components';
import { LocalizationProvider, DatePicker as DatePicker$1, MobileDatePicker } from '@mui/x-date-pickers';
import { AdapterDateFns } from '@mui/x-date-pickers/AdapterDateFnsV3';
import { fr, enUS } from 'date-fns/locale';
import { useTranslation } from 'react-i18next';
import { extractNumberOrBooleanFromString } from '@komune-io/g2-utils';
import { Link as Link$1, useSearchParams } from 'react-router-dom';
import { cx } from '@emotion/css';
import { useFormik } from 'formik';
import { useElementSize, useDidUpdate } from '@mantine/hooks';
import qs from 'qs';
import GeoJSON from 'geojson';
import Markdown from 'react-markdown';
import remarkGfm from 'remark-gfm';
import rehypeRaw from 'rehype-raw';
import { useCellValues, currentFormat$, usePublisher, applyFormat$, currentListType$, applyListType$, convertSelectionToNode$, useCellValue, currentBlockType$, activeEditor$, MDXEditor, headingsPlugin, listsPlugin, quotePlugin, markdownShortcutPlugin, toolbarPlugin } from '@mdxeditor/editor';
import { mergeRegister } from '@lexical/utils';
import { $createParagraphNode, CAN_UNDO_COMMAND, COMMAND_PRIORITY_CRITICAL, CAN_REDO_COMMAND, UNDO_COMMAND, REDO_COMMAND } from 'lexical';
import { $createHeadingNode, $createQuoteNode } from '@lexical/rich-text';

const darkGrey$1 = '#323338';
const textFieldGrey = '#C5C7D0';
const disabledColor = '#E6E9EF';
const useInputStyles = makeG2STyles()((theme) => ({
    root: {
        position: 'relative'
    },
    labelSmall: {
        fontSize: '0.813rem'
    },
    input: {
        '& .MuiInputBase-input': {
            padding: '6px 7px',
            backgroundColor: 'unset',
            borderRadius: 0
        },
        '& .MuiSelect-root': {
            backgroundColor: 'white',
            borderRadius: theme.borderRadius,
            color: '#323338',
            textOverflow: 'ellipsis'
        },
        '& .MuiFilledInput-adornedEnd': {
            paddingRight: '10px'
        },
        '& .MuiFilledInput-adornedStart': {
            paddingLeft: '10px'
        },
        '& .MuiFilledInput-root.Mui-disabled': {
            border: `1px solid ${disabledColor}`,
            backgroundColor: disabledColor
        },
        '& .MuiInputBase-root': {
            width: '100%',
            margin: `0px`,
            paddingTop: '0px',
            border: `1px solid ${textFieldGrey}`,
            boxShadow: '0px 0px 0px 1px transparent',
            borderRadius: theme.borderRadius,
            backgroundColor: 'white'
        },
        '& .MuiSelect-select:focus': {
            background: 'unset'
        },
        '& .MuiInputBase-root.Mui-error': {
            border: `1px solid ${theme.colors.error}`
        },
        '& .MuiInputBase-root:hover': {
            border: `1px solid ${darkGrey$1}`,
            backgroundColor: 'white'
        },
        '& .MuiInputBase-root:focus': {
            border: `1px solid ${theme.colors.primary}`
        },
        '& .MuiInputBase-root.Mui-focused': {
            border: `1px solid ${theme.colors.primary}`
        },
        '& .MuiFormLabel-root.Mui-error': {
            color: theme.colors.error
        },
        '& .MuiInputLabel-filled .MuiInputLabel-filled.MuiInputLabel-shrink': {
            transform: 'translate(12px, 21px) scale(1)'
        },
        '& .MuiFormLabel-root.Mui-focused': {
            fontWeight: 400,
            transform: 'translate(12px, 10px) scale(0.75)'
        },
        '& .MuiFilledInput-underline:before': {
            borderBottom: 'none !important'
        },
        '& .MuiFilledInput-underline:after': {
            borderBottom: 'none'
        },
        '& .MuiFilledInput-input': {
            padding: '0px 10px'
        },
        '& .MuiFilledInput-inputAdornedStart': {
            padding: '0px 10px 0px 0px'
        },
        '& .MuiFilledInput-inputAdornedEnd': {
            padding: '0px 0px 0px 10px'
        },
        '& .MuiFilledInput-input::placeholder': {
            fontSize: '14px'
        },
        '& .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)': {
            marginTop: '0px !important'
        }
    },
    inputValidated: {
        '& .MuiInputBase-root': {
            border: `1px solid ${theme.colors.success}`
        },
        '& .MuiInputBase-root:hover': {
            border: `1px solid ${theme.colors.success}`
        },
        '& .MuiInputBase-root.Mui-focused': {
            border: `1px solid ${theme.colors.success}`
        },
        '& .MuiInputBase-root:focus': {
            border: `1px solid ${theme.colors.success}`
        }
    },
    inputError: {
        '& .MuiInputBase-root': {
            border: `1px solid ${theme.colors.error}`
        },
        '& .MuiInputBase-root:hover': {
            border: `1px solid ${theme.colors.error}`
        },
        '& .MuiInputBase-root.Mui-focused': {
            border: `1px solid ${theme.colors.error}`
        },
        '& .MuiInputBase-root:focus': {
            border: `1px solid ${theme.colors.error}`
        }
    },
    inputLarge: {
        '& .MuiInputBase-root': {
            minHeight: '48px'
        },
        '& .MuiSelect-root': {
            height: '48px',
            lineHeight: '48px'
        }
    },
    inputMedium: {
        '& .MuiInputBase-root': {
            minHeight: '40px'
        },
        '& .MuiSelect-root': {
            height: '40px',
            lineHeight: '40px'
        }
    },
    inputSmall: {
        '& .MuiInputBase-root': {
            minHeight: '32px',
            borderRadius: theme.borderRadius * 0.75
        },
        '& .MuiSelect-root': {
            height: '32px',
            lineHeight: '32px'
        },
        '& .MuiInputBase-input': {
            fontSize: '14px'
        },
        '& .MuiInputBase-input::placeholder': {
            fontSize: '14px'
        }
    },
    inputDisabled: {
        '& .MuiInputBase-root': {
            border: `1px solid ${disabledColor}`,
            background: disabledColor
        },
        '& .MuiInputBase-root:hover': {
            border: `1px solid ${disabledColor}`,
            backgroundColor: disabledColor
        },
        '& .MuiSelect-root': {
            backgroundColor: disabledColor,
            color: '#676879'
        },
        '& .MuiFilledInput-input::placeholder': {
            opacity: 0.9
        }
    },
    inputWithClear: {
        '& .MuiFilledInput-inputAdornedEnd': {
            padding: '0px 15px 0px 10px'
        }
    },
    errorHelperText: {
        position: 'absolute',
        top: '100%',
        color: `${theme.colors.error}`,
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: 1.667,
        width: '100%',
        margin: '0',
        marginTop: '3px'
    },
    helperText: {
        color: `#676879`,
        lineHeight: 1.667,
        width: '100%',
        margin: '0',
        marginTop: '3px'
    },
    clear: {
        position: 'absolute',
        right: '10px',
        top: '50%',
        marginTop: '-12px',
        cursor: 'pointer',
        color: darkGrey$1
    },
    clearError: {
        color: theme.colors.error,
        cursor: 'normal'
    },
    loading: {
        position: 'absolute',
        right: '10px',
        top: '50%',
        marginTop: '-10px',
        cursor: 'pointer',
        color: darkGrey$1
    },
    validated: {
        position: 'absolute',
        right: '10px',
        top: '50%',
        marginTop: '-12px',
        color: theme.colors.success
    }
}));

const darkGrey = '#BDBDBD';
const useFilterInputStyles = makeG2STyles()((theme) => ({
    label: {
        color: '#323338',
        marginBottom: 0,
        fontWeight: 500
    },
    input: {
        '& .MuiInputBase-input': {
            padding: '7px 16px',
            fontSize: '0.875rem',
            height: 'unset',
            color: 'inherit'
        },
        '& .MuiSelect-root': {
            borderRadius: theme.borderRadius,
            textOverflow: 'ellipsis'
        },
        '& .MuiFilledInput-adornedEnd': {
            paddingRight: '10px'
        },
        '& .MuiFilledInput-adornedStart': {
            paddingLeft: '10px'
        },
        '& .MuiInputBase-root': {
            width: '100%',
            margin: `0px`,
            paddingTop: '0px',
            boxShadow: '0px 0px 0px 1px transparent',
            borderRadius: theme.borderRadius * 0.75,
            color: '#323338',
            minWidth: '80px',
            backgroundColor: 'transparent',
            transition: 'background-color 200ms'
        },
        '& .MuiOutlinedInput-notchedOutline': {
            top: '-6.5px',
            bottom: '-1px',
            '& legend': {
                height: 15,
                '& span': {
                    padding: '0px 3px'
                }
            }
        },
        '& .MuiOutlinedInput-adornedStart': {
            paddingLeft: '8px'
        },
        '& .MuiInputAdornment-positionStart': {
            marginRight: '0px'
        },
        '& .MuiOutlinedInput-adornedEnd': {
            paddingRight: '8px'
        },
        '& .MuiInputAdornment-positionEnd': {
            marginLeft: '0px'
        },
        '& .MuiInputBase-root.Mui-disabled': {
            opacity: 0.7
        },
        '& .MuiSelect-select:focus': {
            background: 'unset'
        },
        '& .MuiFormLabel-root.Mui-focused': {
            color: '#323338'
        },
        '& .MuiInputLabel-outlined': {
            transform: 'translate(14px, 6.5px) scale(1)'
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            transform: 'translate(14px, -6px) scale(0.75)',
            top: '-3px'
        },
        '& .MuiFilledInput-underline:before': {
            borderBottom: 'none'
        },
        '& .MuiFilledInput-underline:after': {
            borderBottom: 'none'
        },
        '& .MuiFilledInput-input': {
            padding: '0px 10px'
        },
        '& .MuiFilledInput-inputAdornedStart': {
            padding: '0px 10px 0px 0px'
        },
        '& .MuiFilledInput-inputAdornedEnd': {
            padding: '0px 0px 0px 10px'
        },
        '& .MuiOutlinedInput-input::placeholder': {
            fontSize: '0.875rem',
            color: 'inherit',
            opacity: 1
        },
        '& .MuiInputAdornment-root': {
            color: '#000000'
        },
        '& .MuiInputAdornment-filled.MuiInputAdornment-positionStart:not(.MuiInputAdornment-hiddenLabel)': {
            marginTop: '0px !important'
        }
    },
    inputOutlinedGreyColor: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: `2px solid ${darkGrey}`
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: darkGrey
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: darkGrey
        },
        '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: darkGrey
        }
    },
    inputOutlinedPrimaryColor: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: `2px solid ${theme.colors.primary}`
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.primary
        },
        '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.primary
        }
    },
    inputOutlinedSecondaryColor: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: `2px solid ${theme.colors.secondary}`
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.secondary
        },
        '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.secondary
        }
    },
    inputFilledGreyColor: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: ` 2px solid ${darkGrey}`
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: darkGrey
        },
        '& .MuiOutlinedInput-root.Mui-focused .MuiOutlinedInput-notchedOutline': {
            borderColor: darkGrey
        },
        '& .MuiInputBase-root': {
            backgroundColor: '#F2F2F2'
        },
        '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: darkGrey
        }
    },
    inputFilledPrimaryColor: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: `2px solid ${theme.colors.primary}`
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.primary
        },
        '& .MuiInputBase-root': {
            backgroundColor: theme.colors.primary
        },
        '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.primary
        }
    },
    inputFilledSecondaryColor: {
        '& .MuiOutlinedInput-notchedOutline': {
            border: `2px solid ${theme.colors.secondary}`
        },
        '& .MuiOutlinedInput-root:hover .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.secondary
        },
        '& .MuiInputBase-root': {
            backgroundColor: theme.colors.secondary
        },
        '& .MuiOutlinedInput-root.Mui-disabled .MuiOutlinedInput-notchedOutline': {
            borderColor: theme.colors.secondary
        }
    },
    inputWithClear: {
        '& .MuiFilledInput-inputAdornedEnd': {
            padding: '0px 15px 0px 10px'
        }
    },
    inputWithoutLabel: {
        '& .MuiOutlinedInput-notchedOutline legend span': {
            padding: '0px'
        }
    },
    clear: {
        position: 'absolute',
        right: '12px',
        top: '50%',
        marginTop: '-10px',
        cursor: 'pointer',
        width: '21px',
        height: '21px',
        color: 'inherit'
    }
}));

const useFilterColorStyle = (params) => {
    const { color, variant } = params;
    const theme = useTheme();
    const colorStyle = useMemo(() => {
        if (variant === 'outlined')
            return {};
        if (color === 'primary') {
            const isPrimaryDark = tinycolor(theme.colors.primary).isDark();
            if (isPrimaryDark)
                return { color: 'white' };
        }
        if (color === 'secondary') {
            const isSecondaryDark = tinycolor(theme.colors.secondary).isDark();
            if (isSecondaryDark)
                return { color: 'white' };
        }
        return {};
    }, [color, theme.colors.primary, theme.colors.secondary, variant]);
    return colorStyle;
};

var _path$4;
function _extends$5() { _extends$5 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$5.apply(this, arguments); }
var SvgSelect = function SvgSelect(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$5({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 10 7"
  }, props), _path$4 || (_path$4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.558 6.213 5 5.635l-.558.578a.77.77 0 0 0 1.116 0M5 4.478 1.348.693a.77.77 0 0 0-1.117 0 .84.84 0 0 0 0 1.157l4.21 4.363L5 5.635l.558.578 4.21-4.363a.84.84 0 0 0 0-1.157.77.77 0 0 0-1.116 0z"
  })));
};

const SelectIcon = (props) => {
    const { sx } = props, other = __rest(props, ["sx"]);
    return (React__default.createElement(SvgIcon, Object.assign({ sx: Object.assign({ color: '#FFFFFF' }, sx), component: SvgSelect, inheritViewBox: true }, other)));
};

var _path$3;
function _extends$4() { _extends$4 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$4.apply(this, arguments); }
var SvgSearchIcon = function SvgSearchIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$4({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _path$3 || (_path$3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.652.373a6.34 6.34 0 1 0 3.92 11.32l3.837 3.837a.75.75 0 1 0 1.06-1.06l-3.836-3.837A6.34 6.34 0 0 0 6.652.373m3.439 9.744a4.84 4.84 0 1 0-6.879-6.81 4.84 4.84 0 0 0 6.879 6.81",
    clipRule: "evenodd"
  })));
};

const SearchIcon = (props) => {
    const { sx } = props, other = __rest(props, ["sx"]);
    return (React__default.createElement(SvgIcon, Object.assign({ sx: Object.assign({ color: '#FFFFFF' }, sx), component: SvgSearchIcon, inheritViewBox: true }, other)));
};

var _rect$2;
function _extends$3() { _extends$3 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$3.apply(this, arguments); }
var SvgUnCheckIcon = function SvgUnCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$3({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _rect$2 || (_rect$2 = /*#__PURE__*/React.createElement("rect", {
    width: "calc(100% - 1px)",
    height: "calc(100% - 1px)",
    x: 0.5,
    y: 0.5,
    rx: 1.5
  })));
};

const UnCheckIcon = (props) => {
    return React__default.createElement(SvgIcon, Object.assign({ component: SvgUnCheckIcon, inheritViewBox: true }, props));
};

var _rect$1, _path$2;
function _extends$2() { _extends$2 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$2.apply(this, arguments); }
var SvgCheckIcon = function SvgCheckIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$2({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 16 16"
  }, props), _rect$1 || (_rect$1 = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 2
  })), _path$2 || (_path$2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M6.824 11.395 6.4 10.97l-.425.425a.6.6 0 0 0 .849 0M6.4 10.122 3.624 7.346a.6.6 0 1 0-.849.849l3.2 3.2.425-.425.424.425 6.174-6.174a.6.6 0 0 0-.849-.849z",
    clipRule: "evenodd"
  })));
};

const CheckIcon = (props) => {
    return React__default.createElement(SvgIcon, Object.assign({ component: SvgCheckIcon, inheritViewBox: true }, props));
};

var _path$1;
function _extends$1() { _extends$1 = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends$1.apply(this, arguments); }
var SvgCalendar = function SvgCalendar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends$1({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    strokeWidth: 1.5,
    viewBox: "0 0 20 20"
  }, props), _path$1 || (_path$1 = /*#__PURE__*/React.createElement("path", {
    d: "M2.5 4.5c0-.644.522-1.167 1.167-1.167h12.666c.645 0 1.167.523 1.167 1.167v12.667c0 .644-.522 1.166-1.167 1.166H3.667A1.167 1.167 0 0 1 2.5 17.167zM13.333 1.667V5M6.667 1.667V5M2.5 8.333h15"
  })));
};

const Calendar = (props) => {
    const { sx } = props, other = __rest(props, ["sx"]);
    return (React__default.createElement(SvgIcon, Object.assign({ sx: Object.assign({ color: '#353945' }, sx), component: SvgCalendar, inheritViewBox: true }, other)));
};

const useStyles$9 = makeG2STyles()({
    input: {
        width: '100%'
    },
    withIconStart: {
        '& .MuiInputBase-input': {
            paddingLeft: '0px'
        }
    },
    withIconEnd: {
        '& .MuiInputBase-input': {
            paddingRight: '0px'
        }
    },
    withIconEndOnRemove: {
        '& .MuiInputBase-input': {
            paddingRight: '20px'
        }
    },
    withOnRemove: {
        '& .MuiInputBase-input': {
            paddingRight: '35px'
        }
    },
    searchIcon: {
        width: '20px',
        height: '20px',
        cursor: 'pointer'
    },
    searchIconDisabled: {
        cursor: 'default',
        fill: 'rgba(0, 0, 0, 0.26)'
    },
    endAdornmentWithInputIcon: {
        right: '36px'
    },
    paddingMultiline: {
        '& .MuiInputBase-root': {
            padding: '10px 0px'
        }
    }
});
const TextField = React__default.forwardRef((props, ref) => {
    const { className, error = false, errorMessage = '', label = '', id = '', onChange, placeholder = '', style, textFieldType = 'text', defaultValue, value, disabled = false, helperText, inputIcon, onRemove, classes, styles, iconPosition = 'end', size = 'medium', validated = false, onSearch, InputProps, noCheckOrClearIcon = false, multiline = false, searchLoading = false, noSearchIcon = false } = props, other = __rest(props, ["className", "error", "errorMessage", "label", "id", "onChange", "placeholder", "style", "textFieldType", "defaultValue", "value", "disabled", "helperText", "inputIcon", "onRemove", "classes", "styles", "iconPosition", "size", "validated", "onSearch", "InputProps", "noCheckOrClearIcon", "multiline", "searchLoading", "noSearchIcon"]);
    const defaultStyles = useInputStyles();
    const localStyles = useStyles$9();
    const [loading, setloading] = useState(false);
    const onChangeMemoized = useCallback((e) => {
        onChange && onChange(e.target.value);
    }, [onChange]);
    const onSearchMemoisied = useCallback(async () => {
        if (onSearch) {
            setloading(true);
            await onSearch();
            setloading(false);
        }
    }, [onSearch]);
    const downHandler = useCallback((event) => {
        if ((textFieldType === 'search' || textFieldType === 'search-number') &&
            event.key === 'Enter') {
            event.currentTarget.blur();
            onSearchMemoisied && onSearchMemoisied();
        }
    }, [onSearchMemoisied, textFieldType]);
    const inputAdornment = useMemo(() => {
        const getIcon = () => {
            if ((textFieldType === 'search' || textFieldType === 'search-number') &&
                !noSearchIcon) {
                return (React__default.createElement(SearchIcon, { sx: {
                        color: '#323338'
                    }, onClick: !disabled ? onSearchMemoisied : undefined, className: defaultStyles.cx(localStyles.classes.searchIcon, disabled && localStyles.classes.searchIconDisabled, 'AruiTextfield-searchIcon', classes === null || classes === void 0 ? void 0 : classes.searchIcon), style: styles === null || styles === void 0 ? void 0 : styles.searchIcon }));
            }
            return inputIcon;
        };
        const icon = getIcon();
        if (icon) {
            if (iconPosition === 'start') {
                return {
                    startAdornment: (React__default.createElement(InputAdornment, { component: 'div', position: 'start' }, icon))
                };
            }
            else {
                return {
                    endAdornment: (React__default.createElement(InputAdornment, { component: 'div', position: 'end' }, icon))
                };
            }
        }
        return {};
    }, [
        textFieldType,
        inputIcon,
        iconPosition,
        classes === null || classes === void 0 ? void 0 : classes.searchIcon,
        styles === null || styles === void 0 ? void 0 : styles.searchIcon,
        disabled,
        onSearchMemoisied,
        noSearchIcon
    ]);
    const rightIcon = useMemo(() => {
        if (noCheckOrClearIcon)
            return;
        if (loading || searchLoading) {
            return (React__default.createElement(CircularProgress, { size: 20, className: defaultStyles.cx(defaultStyles.classes.clear, defaultStyles.classes.loading, inputAdornment.endAdornment &&
                    localStyles.classes.endAdornmentWithInputIcon, 'AruiTextfield-loadingIcon', classes === null || classes === void 0 ? void 0 : classes.loadingIcon), style: styles === null || styles === void 0 ? void 0 : styles.loadingIcon }));
        }
        if (validated)
            return (React__default.createElement(CheckRounded, { className: defaultStyles.cx(defaultStyles.classes.validated, inputAdornment.endAdornment &&
                    localStyles.classes.endAdornmentWithInputIcon, 'AruiTextfield-validIcon', classes === null || classes === void 0 ? void 0 : classes.validIcon), style: styles === null || styles === void 0 ? void 0 : styles.validIcon }));
        if ((!value || value === '') && !error)
            return undefined;
        if ((onRemove || error) && !disabled) {
            return (React__default.createElement(ClearRounded, { onClick: onRemove, className: defaultStyles.cx(defaultStyles.classes.clear, inputAdornment.endAdornment &&
                    localStyles.classes.endAdornmentWithInputIcon, error && defaultStyles.classes.clearError, 'AruiTextfield-clearIcon', classes === null || classes === void 0 ? void 0 : classes.clearIcon), style: styles === null || styles === void 0 ? void 0 : styles.clearIcon }));
        }
        return undefined;
    }, [
        value,
        onRemove,
        classes === null || classes === void 0 ? void 0 : classes.clearIcon,
        styles === null || styles === void 0 ? void 0 : styles.clearIcon,
        classes === null || classes === void 0 ? void 0 : classes.validIcon,
        styles === null || styles === void 0 ? void 0 : styles.validIcon,
        inputAdornment.endAdornment,
        noCheckOrClearIcon,
        error,
        disabled,
        searchLoading,
        loading
    ]);
    const inputClasses = () => {
        if (rightIcon) {
            if (inputAdornment.endAdornment) {
                return localStyles.classes.withIconEndOnRemove;
            }
            else {
                return localStyles.classes.withOnRemove;
            }
        }
        return '';
    };
    return (React__default.createElement("div", { className: defaultStyles.cx(defaultStyles.classes.root, 'AruiTextfield-root', className), style: style },
        React__default.createElement(Box, { sx: {
                position: 'relative'
            } },
            React__default.createElement(TextField$1, Object.assign({}, other, { ref: ref, id: id, value: value, onChange: onChangeMemoized, placeholder: placeholder, type: textFieldType === 'search'
                    ? 'text'
                    : textFieldType === 'search-number'
                        ? 'number'
                        : textFieldType, defaultValue: defaultValue, className: defaultStyles.cx(defaultStyles.classes.input, localStyles.classes.input, size === 'large' && defaultStyles.classes.inputLarge, size === 'medium' && defaultStyles.classes.inputMedium, size === 'small' && defaultStyles.classes.inputSmall, multiline && localStyles.classes.paddingMultiline, disabled && defaultStyles.classes.inputDisabled, error && defaultStyles.classes.inputError, validated && defaultStyles.classes.inputValidated, inputAdornment.startAdornment &&
                    localStyles.classes.withIconStart, inputAdornment.endAdornment && localStyles.classes.withIconEnd, inputClasses(), 'AruiTextfield-Textfield', classes === null || classes === void 0 ? void 0 : classes.textfield), style: styles === null || styles === void 0 ? void 0 : styles.textfield, variant: 'filled', error: error, disabled: disabled, color: 'primary', InputProps: Object.assign(Object.assign(Object.assign({}, inputAdornment), { disableUnderline: true, onKeyDown: downHandler, style: Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.input), className: defaultStyles.cx('AruiTextfield-input', classes === null || classes === void 0 ? void 0 : classes.input) }), InputProps), multiline: multiline })),
            rightIcon),
        ((errorMessage !== '' && error) || helperText) && (React__default.createElement(FormHelperText, { className: defaultStyles.cx(errorMessage !== '' && error
                ? defaultStyles.classes.errorHelperText
                : defaultStyles.classes.helperText, 'AruiSelect-helperText', classes === null || classes === void 0 ? void 0 : classes.helperText), style: styles === null || styles === void 0 ? void 0 : styles.helperText }, error ? errorMessage !== null && errorMessage !== void 0 ? errorMessage : helperText : helperText))));
});

var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
var SvgIndeterminateIcon = function SvgIndeterminateIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: "100%",
    height: "100%",
    rx: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M14 11H6c-.55 0-1-.45-1-1s.45-1 1-1h8c.55 0 1 .45 1 1s-.45 1-1 1",
    clipRule: "evenodd"
  })));
};

const IndeterminateIcon = (props) => {
    return React__default.createElement(SvgIcon, Object.assign({ component: SvgIndeterminateIcon, inheritViewBox: true }, props));
};

const useStyles$8 = makeG2STyles()((theme) => ({
    base: {
        position: 'relative',
        width: 'fit-content'
    },
    root: {
        borderRadius: 20,
        padding: `${theme.spacing / 2}px ${theme.spacing * 1.25}px`
    },
    container: {
        marginLeft: '0px',
        marginRight: '0px',
        '& .MuiTypography-root': {
            fontSize: '14px'
        },
        '& .MuiButtonBase-root:hover': {
            background: 'transparent'
        },
        '& .AruiCheckBox-unCheckIcon': {
            stroke: '#C5C7D0',
            fill: 'none'
        },
        '&:hover .AruiCheckBox-unCheckIcon': {
            stroke: '#323338'
        },
        '& .AruiCheckBox-checkIcon rect': {
            fill: theme.colors.primary + 'B3'
        },
        '&:hover .AruiCheckBox-checkIcon rect': {
            fill: theme.colors.primary
        },
        '& .AruiCheckBox-checkIcon path': {
            fill: 'white'
        },
        '& .AruiCheckBox-inderterminateIcon rect': {
            fill: theme.colors.primary + 'B3'
        },
        '&:hover .AruiCheckBox-inderterminateIcon rect': {
            fill: theme.colors.primary
        },
        '& .AruiCheckBox-inderterminateIcon path': {
            fill: 'white'
        }
    },
    containerDisabled: {
        '& .MuiFormControlLabel-label.Mui-disabled': {
            color: 'unset',
            opacity: 0.7
        },
        '& .AruiCheckBox-unCheckIcon': {
            fill: '#E6E9EF',
            stroke: '#E6E9EF'
        },
        '&:hover .AruiCheckBox-unCheckIcon': {
            fill: '#E6E9EF',
            stroke: '#E6E9EF'
        },
        '& .AruiCheckBox-checkIcon rect': {
            fill: '#E6E9EF'
        },
        '&:hover .AruiCheckBox-checkIcon rect': {
            fill: '#E6E9EF'
        },
        '& .AruiCheckBox-checkIcon path': {
            fill: '#676879'
        },
        '& .AruiCheckBox-inderterminateIcon rect': {
            fill: '#E6E9EF'
        },
        '&:hover .AruiCheckBox-inderterminateIcon rect': {
            fill: '#E6E9EF'
        },
        '& .AruiCheckBox-inderterminateIcon path': {
            fill: '#676879'
        }
    },
    iconSize: {
        width: '20px',
        height: '20px'
    },
    helperText: {
        position: 'absolute',
        top: '100%',
        marginTop: '-2px',
        marginLeft: '12px',
        whiteSpace: 'nowrap',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        lineHeight: 1.667,
        color: theme.colors.error,
        width: '100%'
    }
}));
const CheckBoxBase = (props, ref) => {
    const { checked = false, label = '', className, style, id, classes, styles, error, disabled = false, errorMessage, isLoading = false, readOnly = false, createInputContainer, sx } = props, other = __rest(props, ["checked", "label", "className", "style", "id", "classes", "styles", "error", "disabled", "errorMessage", "isLoading", "readOnly", "createInputContainer", "sx"]);
    const defaultStyles = useStyles$8();
    const formControl = (React__default.createElement(FormControlLabel, { className: defaultStyles.cx(defaultStyles.classes.container, (disabled || readOnly) && defaultStyles.classes.containerDisabled, 'AruiCheckBox-root', classes === null || classes === void 0 ? void 0 : classes.formControl), style: styles === null || styles === void 0 ? void 0 : styles.formControl, control: React__default.createElement(Checkbox, Object.assign({ ref: ref }, other, { checked: checked, disabled: disabled || readOnly, id: id, className: defaultStyles.cx(defaultStyles.classes.root, 'AruiCheckBox-checkbox', classes === null || classes === void 0 ? void 0 : classes.checkbox), style: styles === null || styles === void 0 ? void 0 : styles.checkbox, disableRipple: true, icon: React__default.createElement(UnCheckIcon, { className: defaultStyles.cx(defaultStyles.classes.iconSize, 'AruiCheckBox-unCheckIcon', classes === null || classes === void 0 ? void 0 : classes.checkIcon), style: styles === null || styles === void 0 ? void 0 : styles.checkIcon }), checkedIcon: React__default.createElement(CheckIcon, { className: defaultStyles.cx(defaultStyles.classes.iconSize, 'AruiCheckBox-checkIcon', classes === null || classes === void 0 ? void 0 : classes.unCheckIcon), style: styles === null || styles === void 0 ? void 0 : styles.unCheckIcon }), indeterminateIcon: React__default.createElement(IndeterminateIcon, { className: defaultStyles.cx(defaultStyles.classes.iconSize, 'AruiCheckBox-inderterminateIcon', classes === null || classes === void 0 ? void 0 : classes.inderterminateIcon), style: styles === null || styles === void 0 ? void 0 : styles.inderterminateIcon }) })), label: label, labelPlacement: 'end' }));
    return (React__default.createElement(Box, { className: defaultStyles.cx(defaultStyles.classes.base, 'AruiTextfield-root', className), style: style, sx: sx },
        isLoading && (React__default.createElement(Box, { sx: {
                display: 'flex',
                gap: '10px'
            } },
            React__default.createElement(Skeleton, { animation: 'wave', sx: { width: '20px', height: '20px', transform: 'none' } }),
            React__default.createElement(Skeleton, { animation: 'wave', sx: { width: '150px', height: '20px', transform: 'none' } }))),
        !isLoading &&
            (createInputContainer
                ? createInputContainer(formControl)
                : formControl),
        errorMessage !== '' && error && (React__default.createElement(FormHelperText, { className: defaultStyles.cx(defaultStyles.classes.helperText, 'AruiCheckBox-helperText', classes === null || classes === void 0 ? void 0 : classes.helperText), style: styles === null || styles === void 0 ? void 0 : styles.helperText }, errorMessage))));
};
const CheckBox = forwardRef(CheckBoxBase);

const useStyles$7 = makeG2STyles()({
    list: {
        padding: '0px'
    }
});
const defaultFilterOptions = createFilterOptions();
const defaultGetOptionLabel = (options, hasKey) => (option) => {
    var _a, _b;
    if (typeof option === 'string' && hasKey) {
        const founded = (_a = options.find((el) => el.key === option)) === null || _a === void 0 ? void 0 : _a.label;
        if (founded)
            return founded;
    }
    return typeof option === 'string' ? option : (_b = option.label) !== null && _b !== void 0 ? _b : '';
};
const AutoCompleteBase = function (props, ref) {
    var _a;
    const { className, style, multiple = false, id, options = [], value, values, onChangeValue, onChangeValues, defaultValue = null, onSearch, getOptionLabel, textFieldProps, disabled, isOptionEqualToValue, noFilterDisplayOptions = true, noFilterOptions = false, optionsResultLimit = -1, error = false, errorMessage = '', withCheckbox = true, returnFullObject = false, chipProps, helperText } = props, other = __rest(props
    //@ts-ignore
    , ["className", "style", "multiple", "id", "options", "value", "values", "onChangeValue", "onChangeValues", "defaultValue", "onSearch", "getOptionLabel", "textFieldProps", "disabled", "isOptionEqualToValue", "noFilterDisplayOptions", "noFilterOptions", "optionsResultLimit", "error", "errorMessage", "withCheckbox", "returnFullObject", "chipProps", "helperText"]);
    //@ts-ignore
    const hasKey = !!((_a = options[0]) === null || _a === void 0 ? void 0 : _a.key);
    const defaultOptionLabelMemo = useCallback((option) => defaultGetOptionLabel(options, hasKey)(option), [options, hasKey]);
    const getOptionLabelMemo = getOptionLabel !== null && getOptionLabel !== void 0 ? getOptionLabel : defaultOptionLabelMemo;
    const defaultStyles = useStyles$7();
    const onChangeMemoized = useCallback((_, value) => {
        if (Array.isArray(value) && onChangeValues) {
            //@ts-ignore
            if (hasKey && !getOptionLabel && !returnFullObject) {
                //@ts-ignore
                onChangeValues(value.map((value) => { var _a; return (_a = value.key) !== null && _a !== void 0 ? _a : value; }));
            }
            else {
                onChangeValues(value);
            }
        }
        else if (onChangeValue && !Array.isArray(value)) {
            //@ts-ignore
            if (!!(value === null || value === void 0 ? void 0 : value.key) && !getOptionLabel && !returnFullObject) {
                //@ts-ignore
                onChangeValue(value.key);
            }
            else {
                onChangeValue(value !== null && value !== void 0 ? value : undefined);
            }
        }
    }, [onChangeValue, onChangeValues, getOptionLabel, returnFullObject, hasKey]);
    const renderTags = useCallback((value, getTagProps) => value.map((option, index) => {
        var _a;
        const _b = getTagProps({ index }), { key } = _b, other = __rest(_b, ["key"]);
        return (React__default.createElement(Chip
        //@ts-ignore
        , Object.assign({ 
            //@ts-ignore
            key: (_a = option.key) !== null && _a !== void 0 ? _a : key, label: getOptionLabelMemo(option) }, chipProps, other)));
    }), [getOptionLabelMemo, chipProps]);
    const renderInput = useCallback((params) => {
        return (React__default.createElement(TextField, Object.assign({}, textFieldProps, params, { error: error, errorMessage: errorMessage, noCheckOrClearIcon: true, helperText: helperText })));
    }, [textFieldProps, error, errorMessage, helperText]);
    const renderOption = useCallback((props, option, { selected }) => {
        var _a, _b;
        //@ts-ignore
        const { key } = props, other = __rest(props, ["key"]);
        return (React__default.createElement(ListItem
        //@ts-ignore
        , Object.assign({ 
            //@ts-ignore
            key: (_b = (_a = option.key) === null || _a === void 0 ? void 0 : _a.toString()) !== null && _b !== void 0 ? _b : key, className: defaultStyles.cx('AruiAutoComplete-option') }, other),
            withCheckbox && React__default.createElement(CheckBox, { checked: selected }),
            React__default.createElement(ListItemText, { primary: getOptionLabelMemo(option) })));
    }, [getOptionLabelMemo, withCheckbox]);
    const filterOptions = useCallback((options, state) => {
        const inputTrimmed = state.inputValue.trim();
        if (!noFilterDisplayOptions && !inputTrimmed)
            return [];
        const result = noFilterOptions
            ? options
            : defaultFilterOptions(options, state);
        if (optionsResultLimit >= 0) {
            return result.splice(0, optionsResultLimit);
        }
        return result;
    }, [noFilterDisplayOptions, optionsResultLimit, noFilterOptions]);
    const defaultIsOptionEqualToValue = useCallback(
    //@ts-ignore
    (option, value) => option.key === value.key || option.key === value, []);
    return (React__default.createElement(Autocomplete, Object.assign({ id: id, ref: ref, value: multiple ? values : value, limitTags: 2, multiple: multiple, options: options, className: defaultStyles.cx('AruiAutoComplete-root', className), getOptionLabel: getOptionLabelMemo, style: style, disabled: disabled, disableCloseOnSelect: multiple, onChange: onChangeMemoized, renderTags: renderTags, renderInput: renderInput, renderOption: renderOption, isOptionEqualToValue: isOptionEqualToValue !== null && isOptionEqualToValue !== void 0 ? isOptionEqualToValue : (hasKey ? defaultIsOptionEqualToValue : undefined), filterOptions: filterOptions, classes: {
            listbox: defaultStyles.classes.list
        } }, other)));
};
const AutoComplete = forwardRef(AutoCompleteBase);

const CustomActionBar = (props) => {
    const { onAccept, onClear, onCancel, onSetToday, actions } = props;
    const { t } = useTranslation();
    const actionsDisplay = useMemo(() => actions === null || actions === void 0 ? void 0 : actions.map((actionType) => {
        let action = undefined;
        let text = '';
        let variant = 'contained';
        switch (actionType) {
            case 'clear':
                action = onClear;
                text = t('g2.clear');
                break;
            case 'cancel':
                action = onCancel;
                text = t('g2.cancel');
                variant = 'text';
                break;
            case 'accept':
                action = onAccept;
                text = t('g2.accept');
                break;
            case 'today':
                action = onSetToday;
                text = t('g2.today');
                break;
        }
        return {
            key: actionType,
            label: text,
            onClick: action,
            //@ts-ignore
            variant: variant
        };
    }), [actions, t]);
    if (actions == null || actions.length === 0) {
        return null;
    }
    return (React__default.createElement(Actions, { padding: 1, actions: actionsDisplay, sx: {
            gridColumn: '1 / 4',
            gridRow: 3
        } }));
};

const dateFnsLocales$1 = {
    fr,
    enUS
};
const useStyles$6 = makeG2STyles()((theme) => ({
    input: {
        width: '100%'
    },
    dialog: {
        '& .MuiButton-root': {
            background: theme.colors.primary,
            padding: '3px 5px',
            textTransform: 'lowercase'
        }
    }
}));
const DatePickerBase = (props, ref) => {
    const { value, onChangeDate, className, style, id, minDate, maxDate, disabled = false, placeholder = 'jj/MM/yyyy', size = 'medium', onRemove, textFieldProps, name, error, errorMessage, helperText, classes, styles } = props, other = __rest(props, ["value", "onChangeDate", "className", "style", "id", "minDate", "maxDate", "disabled", "placeholder", "size", "onRemove", "textFieldProps", "name", "error", "errorMessage", "helperText", "classes", "styles"]);
    const defaultStyles = useInputStyles();
    const localStyles = useStyles$6();
    const { i18n } = useTranslation();
    const format = useMemo(() => {
        if (i18n.language === 'fr')
            return {
                format: 'dd/MM/yyyy',
                views: ['day', 'month', 'year']
            };
        return {
            format: 'yyyy/MM/dd',
            views: ['year', 'month', 'day']
        };
    }, [i18n.language]);
    const onChange = useCallback((date) => {
        onChangeDate && onChangeDate(date ? new Date(date) : undefined);
    }, [onChangeDate]);
    const formHelperProps = useMemo(() => {
        return {
            className: defaultStyles.cx(errorMessage !== '' && error
                ? defaultStyles.classes.errorHelperText
                : defaultStyles.classes.helperText, 'AruiTextfield-helperText', classes === null || classes === void 0 ? void 0 : classes.helperText),
            style: styles === null || styles === void 0 ? void 0 : styles.helperText
        };
    }, [classes === null || classes === void 0 ? void 0 : classes.helperText, styles === null || styles === void 0 ? void 0 : styles.helperText, errorMessage, error]);
    return (React__default.createElement(LocalizationProvider, { dateAdapter: AdapterDateFns, adapterLocale: dateFnsLocales$1[i18n.language === 'en' ? 'enUS' : 'fr'] },
        React__default.createElement(DatePicker$1, Object.assign({ ref: ref, format: format.format, views: format.views, minDate: minDate, maxDate: maxDate, orientation: 'portrait', slotProps: {
                actionBar: {
                    actions: ['cancel', 'clear']
                },
                dialog: {
                    className: localStyles.classes.dialog
                },
                textField: {
                    name,
                    variant: 'filled',
                    error,
                    className: defaultStyles.cx(localStyles.classes.input, defaultStyles.classes.input, size === 'large' && defaultStyles.classes.inputLarge, size === 'medium' && defaultStyles.classes.inputMedium, size === 'small' && defaultStyles.classes.inputSmall, error && defaultStyles.classes.inputError, disabled && defaultStyles.classes.inputDisabled, 'AruiDatePicker-datePicker', className),
                    style,
                    helperText: error ? errorMessage !== null && errorMessage !== void 0 ? errorMessage : helperText : helperText,
                    color: 'primary',
                    InputProps: Object.assign({ disableUnderline: true, style: styles === null || styles === void 0 ? void 0 : styles.input, className: defaultStyles.cx('AruiDatePicker-input', classes === null || classes === void 0 ? void 0 : classes.input) }, textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputProps),
                    FormHelperTextProps: formHelperProps,
                    placeholder: placeholder
                }
            }, slots: {
                actionBar: CustomActionBar
            }, disabled: disabled, value: value || null, onChange: onChange }, other))));
};
const DatePicker = forwardRef(DatePickerBase);

const useStyles$5 = makeG2STyles()({
    formcontrol: {
        width: '100%'
    },
    root: {
        '& .MuiFilledInput-input': {
            margin: '0px 5px'
        }
    },
    disabledStyle: {
        '& .MuiSelect-root': {
            color: '#676879B3',
            fontSize: '14px'
        }
    },
    clear: {
        position: 'absolute',
        right: '35px',
        top: '50%',
        marginTop: '-12px',
        cursor: 'pointer',
        color: 'rgba(0, 0, 0, 0.54)'
    },
    list: {
        padding: '0px'
    },
    selectPaddingWithClear: {
        paddingRight: '12px'
    },
    selectPadding: {
        '& .MuiSelect-root': {
            paddingRight: '30px',
            margin: '0px'
        }
    },
    menu: {
        marginTop: '5px'
    }
});
const Select = React__default.forwardRef((props, ref) => {
    var _a;
    const { value = '', values = [], onChangeValue, onChangeValues, name, options = [], className, placeholder = '', style, id, error = false, errorMessage = '', onRemove, disabled = false, classes, styles, size = 'medium', multiple = false, startAdornment, onClose, helperText } = props, other = __rest(props, ["value", "values", "onChangeValue", "onChangeValues", "name", "options", "className", "placeholder", "style", "id", "error", "errorMessage", "onRemove", "disabled", "classes", "styles", "size", "multiple", "startAdornment", "onClose", "helperText"]);
    const defaultStyles = useInputStyles();
    const localStyles = useStyles$5();
    const onChangeMemoized = useCallback((event) => {
        const eventValue = event.target.value;
        if (Array.isArray(eventValue)) {
            onChangeValues &&
                onChangeValues(extractNumberOrBooleanFromString(eventValue));
        }
        else {
            onChangeValue &&
                onChangeValue(extractNumberOrBooleanFromString(eventValue));
        }
    }, [onChangeValue, onChangeValues]);
    const optionsMap = useMemo(() => new Map(options.map((el) => [el.key, el])), [options]);
    const currentOption = useMemo(() => (value ? optionsMap.get(value) : undefined), [value, optionsMap]);
    const renderValue = useCallback((selected) => {
        var _a;
        if ((!Array.isArray(selected) && selected === '') ||
            (Array.isArray(selected) && selected.length === 0)) {
            return placeholder;
        }
        if (Array.isArray(selected) && selected.length > 0) {
            return selected
                .map((el) => { var _a; return (_a = optionsMap.get(el)) === null || _a === void 0 ? void 0 : _a.label; })
                .filter((el) => el !== undefined)
                .join(', ');
        }
        if (!Array.isArray(selected)) {
            return (_a = optionsMap.get(selected)) === null || _a === void 0 ? void 0 : _a.label;
        }
        return '';
    }, [placeholder, optionsMap]);
    const selectIcon = useCallback((props) => (React__default.createElement(SelectIcon, Object.assign({}, props, { color: '#98A5AE', className: defaultStyles.cx('AruiSelect-selectIcon', classes === null || classes === void 0 ? void 0 : classes.selectIcon, props.className), sx: {
            width: '12px',
            height: '12px'
        }, style: Object.assign({ right: '10px', top: 'calc(50% - 5px)' }, styles === null || styles === void 0 ? void 0 : styles.selectIcon) }))), []);
    const optionsMemoized = useMemo(() => {
        return options.map((option) => (
        //@ts-ignore
        React__default.createElement(MenuItem, { "data-value": option.key.toString(), className: defaultStyles.cx('AruiSelect-option', classes === null || classes === void 0 ? void 0 : classes.option), style: styles === null || styles === void 0 ? void 0 : styles.option, key: option.key.toString(), value: option.key },
            React__default.createElement(CheckBox, { "data-value": option.key.toString(), checked: values.indexOf(option.key) > -1 || value === option.key }),
            option.icon && React__default.createElement(ListItemIcon, null, option.icon),
            React__default.createElement(ListItemText, { "data-value": option.key.toString(), primary: option.label }))));
    }, [options, values, value, classes === null || classes === void 0 ? void 0 : classes.option, styles === null || styles === void 0 ? void 0 : styles.option]);
    const inputProp = useMemo(() => {
        return {
            name: name,
            className: defaultStyles.cx('AruiSelect-select', classes === null || classes === void 0 ? void 0 : classes.input),
            style: styles === null || styles === void 0 ? void 0 : styles.input,
            id: id
        };
    }, [name, onRemove, value, classes === null || classes === void 0 ? void 0 : classes.input, styles === null || styles === void 0 ? void 0 : styles.input, id]);
    const onCloseMemoized = useCallback((event) => {
        //@ts-ignore
        const valueClicked = event.currentTarget.dataset.value;
        onRemove &&
            value &&
            valueClicked &&
            value.toString() === valueClicked.toString() &&
            onRemove();
        onClose && onClose(event);
    }, [value, onRemove, onClose]);
    const canRemove = (value !== '' || values.length > 0) && onRemove && !disabled;
    return (React__default.createElement(FormControl, { variant: 'filled', className: defaultStyles.cx(defaultStyles.classes.input, localStyles.classes.formcontrol, size === 'large' && defaultStyles.classes.inputLarge, size === 'medium' && defaultStyles.classes.inputMedium, size === 'small' && defaultStyles.classes.inputSmall, disabled && defaultStyles.classes.inputDisabled, error && defaultStyles.classes.inputError, 'AruiSelect-root', className), style: style, error: error },
        React__default.createElement(Box, { sx: {
                position: 'relative'
            } },
            React__default.createElement(Select$1, Object.assign({}, other, { ref: ref, className: defaultStyles.cx(localStyles.classes.root, values && value === '' && values.length <= 0 && placeholder
                    ? localStyles.classes.disabledStyle
                    : '', canRemove
                    ? localStyles.classes.selectPaddingWithClear
                    : localStyles.classes.selectPadding, 'AruiSelect-select', classes === null || classes === void 0 ? void 0 : classes.select), variant: 'filled', value: multiple ? values : value, onClose: onCloseMemoized, multiple: multiple, IconComponent: selectIcon, onChange: onChangeMemoized, startAdornment: (_a = currentOption === null || currentOption === void 0 ? void 0 : currentOption.icon) !== null && _a !== void 0 ? _a : startAdornment, inputProps: inputProp, renderValue: renderValue, displayEmpty: true, MenuProps: {
                    anchorOrigin: {
                        vertical: 'bottom',
                        horizontal: 'center'
                    },
                    transformOrigin: {
                        vertical: 'top',
                        horizontal: 'center'
                    },
                    classes: { list: localStyles.classes.list },
                    className: defaultStyles.cx(localStyles.classes.menu, 'AruiSelect-menu', classes === null || classes === void 0 ? void 0 : classes.menu),
                    style: styles === null || styles === void 0 ? void 0 : styles.menu
                }, style: styles === null || styles === void 0 ? void 0 : styles.select, disabled: disabled }), optionsMemoized),
            canRemove && (React__default.createElement(ClearRounded, { onClick: onRemove, className: defaultStyles.cx(localStyles.classes.clear, 'AruiSelect-clearIcon', classes === null || classes === void 0 ? void 0 : classes.clearIcon), style: styles === null || styles === void 0 ? void 0 : styles.clearIcon }))),
        ((errorMessage !== '' && error) || helperText) && (React__default.createElement(FormHelperText, { className: defaultStyles.cx(errorMessage !== '' && error
                ? defaultStyles.classes.errorHelperText
                : defaultStyles.classes.helperText, 'AruiSelect-helperText', classes === null || classes === void 0 ? void 0 : classes.helperText), style: styles === null || styles === void 0 ? void 0 : styles.helperText }, error ? errorMessage !== null && errorMessage !== void 0 ? errorMessage : helperText : helperText))));
});

const RadioChoices = React__default.forwardRef((props, ref) => {
    const { value = '', name, choices, options = [], className, onChange, style, id, error = false, errorMessage = '', classes, styles, helperText } = props, other = __rest(props, ["value", "name", "choices", "options", "className", "onChange", "style", "id", "error", "errorMessage", "classes", "styles", "helperText"]);
    const [editableLabel, setEditableLabel] = useState({
        label: ''
    });
    useEffect(() => {
        (choices !== null && choices !== void 0 ? choices : options).forEach((choice) => {
            if (choice.editableLabel && !editableLabel.label) {
                setEditableLabel({
                    key: choice.key,
                    label: choice.label
                });
            }
        });
    }, [options, choices]);
    useEffect(() => {
        if (value &&
            !(choices !== null && choices !== void 0 ? choices : options).find((option) => option.key === value)) {
            const editable = (choices !== null && choices !== void 0 ? choices : options).find((choice) => choice.editableLabel);
            if (editable) {
                setEditableLabel({
                    key: editable.key,
                    label: value.toString()
                });
            }
        }
    }, []);
    const editedLabelKey = useMemo(() => {
        if (editableLabel.label === value) {
            return editableLabel.key;
        }
        return undefined;
    }, [value, editableLabel.label]);
    const onChangeMemoized = useCallback((_, value) => {
        const edited = value === editableLabel.key ? editableLabel.label : undefined;
        onChange && onChange(edited !== null && edited !== void 0 ? edited : extractNumberOrBooleanFromString(value));
    }, [onChange, editableLabel]);
    const defaultStyles = useInputStyles();
    const choicesMemoized = useMemo(() => {
        return (choices !== null && choices !== void 0 ? choices : options).map((choice) => (React__default.createElement(FormControlLabel, Object.assign({ key: choice.key.toString(), value: choice.key, label: choice.editableLabel ? (React__default.createElement(TextField, Object.assign({}, choice.editableLabelProps, { value: editableLabel.label, onChange: (value) => {
                    setEditableLabel({
                        key: choice.key,
                        label: value
                    });
                    onChange && onChange(value);
                } }))) : (choice.label) }, choice.props, { control: React__default.createElement(Radio, null), color: 'primary', className: defaultStyles.cx('AruiRadioChoices-choice', classes === null || classes === void 0 ? void 0 : classes.choice), style: styles === null || styles === void 0 ? void 0 : styles.choice }))));
    }, [choices, options, classes === null || classes === void 0 ? void 0 : classes.choice, styles === null || styles === void 0 ? void 0 : styles.choice, editableLabel]);
    const errorText = useMemo(() => (errorMessage !== '' && error) || helperText ? (React__default.createElement(FormHelperText, { className: defaultStyles.cx(errorMessage !== '' && error
            ? defaultStyles.classes.errorHelperText
            : defaultStyles.classes.helperText, 'AruiRadioChoices-helperText', classes === null || classes === void 0 ? void 0 : classes.helperText), style: styles === null || styles === void 0 ? void 0 : styles.helperText }, error ? errorMessage !== null && errorMessage !== void 0 ? errorMessage : helperText : helperText)) : (React__default.createElement(React__default.Fragment, null)), [errorMessage, error, helperText]);
    return (React__default.createElement("div", { className: defaultStyles.cx(defaultStyles.classes.root, 'AruiRadioChoices-root', className), style: style },
        React__default.createElement(RadioGroup, Object.assign({ id: id, ref: ref, value: editedLabelKey !== null && editedLabelKey !== void 0 ? editedLabelKey : value, onChange: onChangeMemoized, name: name, className: defaultStyles.cx('AruiRadioChoices-root', className), style: style }, other),
            choicesMemoized,
            errorText)));
});

const LoadingRenderer = (props) => {
    const { inputType, size = 'medium' } = props;
    return inputType === 'radioChoices' ? (React__default.createElement(Skeleton, { sx: {
            width: '150px',
            height: '100px',
            transform: 'none'
        }, animation: 'wave' })) : (React__default.createElement(Skeleton, { sx: {
            width: '100%',
            height: size === 'small' ? '32px' : size === 'medium' ? '40px' : '48px',
            transform: 'none'
        }, animation: 'wave' }));
};

const getLabelOfOption = (option, getOptionLabel) => {
    if (option) {
        if (getOptionLabel)
            return getOptionLabel(option);
        if (option.label)
            return option.label;
    }
    return undefined;
};
const ReadOnlyRenderer = (props) => {
    const { readOnlyType = 'text', inputType, value, values, choices, options, multiple, getReadOnlyChipColor, getReadOnlyTextUrl, getOptionLabel, readOnlyElement, emptyValueInReadOnly, size } = props;
    const hoptions = options !== null && options !== void 0 ? options : choices;
    const valuesIsEmpty = (props.value == undefined || props.value === '') &&
        (props.values == undefined || props.values.length === 0);
    const textToDisplay = useMemo(() => {
        var _a;
        if (valuesIsEmpty)
            return emptyValueInReadOnly;
        if (inputType === 'datePicker')
            return new Date(value).toLocaleDateString();
        if (inputType === 'radioChoices' && hoptions && value)
            return (_a = hoptions.find((c) => c.key === value)) === null || _a === void 0 ? void 0 : _a.label;
        if (multiple) {
            if (hoptions && values) {
                return values
                    .map((v) => getLabelOfOption(hoptions.find((o) => o.key === v || o.key === v.key), getOptionLabel))
                    .join(', ');
            }
        }
        else if (hoptions && value !== undefined) {
            const option = hoptions.find((c) => c.key === value || c.key === (value === null || value === void 0 ? void 0 : value.key));
            return getLabelOfOption(option, getOptionLabel);
        }
        return typeof value === 'string' || typeof value === 'number' ? value : '';
    }, [
        inputType,
        value,
        values,
        multiple,
        hoptions,
        getOptionLabel,
        emptyValueInReadOnly,
        valuesIsEmpty
    ]);
    const renderTag = useMemo(() => {
        var _a;
        if (readOnlyType !== 'chip')
            return undefined;
        if (!multiple || valuesIsEmpty) {
            const option = hoptions === null || hoptions === void 0 ? void 0 : hoptions.find((o) => o.key === value);
            return (React__default.createElement(Chip, { label: textToDisplay, color: (_a = option === null || option === void 0 ? void 0 : option.color) !== null && _a !== void 0 ? _a : (getReadOnlyChipColor && getReadOnlyChipColor(textToDisplay)) }));
        }
        else if (hoptions && values) {
            return values.map((value) => {
                var _a;
                const option = hoptions.find((o) => o.key === value);
                if (!option)
                    return undefined;
                const label = getLabelOfOption(option, getOptionLabel);
                return (React__default.createElement(Chip, { key: option.key.toString(), label: `${label}`, color: (_a = option === null || option === void 0 ? void 0 : option.color) !== null && _a !== void 0 ? _a : (getReadOnlyChipColor && getReadOnlyChipColor(option === null || option === void 0 ? void 0 : option.key)) }));
            });
        }
        return;
    }, [readOnlyType, textToDisplay, value, values, hoptions, valuesIsEmpty]);
    const renderCustom = useMemo(() => {
        if ((readOnlyType !== 'customElement' &&
            readOnlyType !== 'customContainer') ||
            !readOnlyElement)
            return undefined;
        const Element = readOnlyElement;
        if (!multiple) {
            return React__default.createElement(Element, { valueKey: value, value: textToDisplay });
        }
        else if (hoptions && values && readOnlyType === 'customElement') {
            return values.map((value) => {
                const option = hoptions.find((o) => o.key === value);
                if (!option)
                    return undefined;
                const label = getLabelOfOption(option, getOptionLabel);
                return (React__default.createElement(Element, { key: option.key.toString(), valueKey: option.key, value: `${label}` }));
            });
        }
        else if (hoptions && values && readOnlyType === 'customContainer') {
            const completeValues = [];
            values.forEach((value) => {
                const option = hoptions.find((o) => o.key === value);
                if (option)
                    completeValues.push(option);
            });
            return React__default.createElement(Element, { values: completeValues });
        }
        return;
    }, [readOnlyType, textToDisplay, value, values, hoptions, readOnlyElement]);
    const url = useMemo(() => {
        if (!value || !getReadOnlyTextUrl)
            return undefined;
        return getReadOnlyTextUrl(value);
    }, [value, getReadOnlyTextUrl]);
    if (readOnlyType === 'text') {
        if (url)
            return (React__default.createElement(Link, { componentProps: { to: url }, component: Link$1, sx: { color: '#676879' }, variant: size === 'small' ? 'body2' : 'body1', className: 'AruiInputForm-readOnlyLink' }, textToDisplay));
        else
            return (React__default.createElement(Typography, { sx: { color: '#676879' }, variant: size === 'small' ? 'body2' : 'body1', className: 'AruiInputForm-readOnlyText' }, textToDisplay));
    }
    if (readOnlyType === 'chip') {
        return (React__default.createElement(Stack, { direction: 'row', alignItems: 'center', flexWrap: 'wrap', sx: {
                gap: (theme) => theme.spacing(0.5)
            } }, renderTag));
    }
    if (readOnlyType === 'customElement') {
        return (React__default.createElement(Stack, { direction: 'row', alignItems: 'center', flexWrap: 'wrap', sx: {
                gap: (theme) => theme.spacing(0.5)
            } }, renderCustom));
    }
    return React__default.createElement(React__default.Fragment, null, renderCustom);
};

const MultiChoices = React__default.forwardRef((props, ref) => {
    const { values = [], options = [], className, onChange, style, id, error = false, errorMessage = '', classes, styles, helperText } = props, other = __rest(props, ["values", "options", "className", "onChange", "style", "id", "error", "errorMessage", "classes", "styles", "helperText"]);
    const onChangeMemoized = useCallback((key, checked) => {
        const valuesCopy = [...values];
        if (checked)
            valuesCopy.push(key);
        else {
            const index = values.findIndex((value) => key === value);
            valuesCopy.splice(index, 1);
        }
        onChange && onChange(valuesCopy);
    }, [onChange, values]);
    const defaultStyles = useInputStyles();
    const choicesMemoized = useMemo(() => {
        return options.map((choice) => (React__default.createElement(CheckBox, { key: choice.key.toString(), checked: values.includes(choice.key), onChange: (_, checked) => onChangeMemoized(choice.key, checked), label: choice.label, className: defaultStyles.cx('AruiMultiChoices-choice', classes === null || classes === void 0 ? void 0 : classes.choice), sx: {
                paddingLeft: 0
            }, style: styles === null || styles === void 0 ? void 0 : styles.choice })));
    }, [options, values, classes === null || classes === void 0 ? void 0 : classes.choice, styles === null || styles === void 0 ? void 0 : styles.choice, onChangeMemoized]);
    const errorText = useMemo(() => (errorMessage !== '' && error) || helperText ? (React__default.createElement(FormHelperText, { className: defaultStyles.cx(errorMessage !== '' && error
            ? defaultStyles.classes.errorHelperText
            : defaultStyles.classes.helperText, 'AruiMultiChoices-helperText', classes === null || classes === void 0 ? void 0 : classes.helperText), style: styles === null || styles === void 0 ? void 0 : styles.helperText }, error ? errorMessage !== null && errorMessage !== void 0 ? errorMessage : helperText : helperText)) : (React__default.createElement(React__default.Fragment, null)), [errorMessage, error, helperText]);
    return (React__default.createElement(FormControl, Object.assign({ id: id, ref: ref, error: error, className: defaultStyles.cx('AruiMultiChoices-root', className), style: style, variant: 'standard' }, other),
        React__default.createElement(FormGroup, null, choicesMemoized),
        errorText));
});

//@ts-ignore
const InputForm = React__default.forwardRef((props, ref) => {
    const { inputType = 'textField', readOnly = false, className, style, label, description, id, classes, styles, inputClasses, inputStyles, size = 'medium', isLoading = false, createInputContainer, getReadOnlyChipColor, readOnlyType, getReadOnlyTextUrl, orientation = 'vertical', emptyValueInReadOnly, sx } = props, other = __rest(props, ["inputType", "readOnly", "className", "style", "label", "description", "id", "classes", "styles", "inputClasses", "inputStyles", "size", "isLoading", "createInputContainer", "getReadOnlyChipColor", "readOnlyType", "getReadOnlyTextUrl", "orientation", "emptyValueInReadOnly", "sx"]);
    const defaultStyles = useInputStyles();
    const labelUi = useMemo(() => {
        return (React__default.createElement(Stack, { gap: 1, className: 'AruiInputForm-labelContainer', sx: {
                marginBottom: '8px'
            } },
            label && (React__default.createElement(InputLabel, { htmlFor: id, className: defaultStyles.cx(size === 'small' && defaultStyles.classes.labelSmall, classes === null || classes === void 0 ? void 0 : classes.label, 'AruiInputForm-label'), style: styles === null || styles === void 0 ? void 0 : styles.label, sx: {
                    margin: 'unset'
                } }, label)),
            description && (React__default.createElement(Typography, { className: 'AruiInputForm-description', variant: 'body2' }, description))));
    }, [label, classes === null || classes === void 0 ? void 0 : classes.label, id, styles === null || styles === void 0 ? void 0 : styles.label, size, description]);
    const inputUi = useMemo(() => {
        const commonProps = {
            size,
            className: cx(classes === null || classes === void 0 ? void 0 : classes.input, 'AruiInputForm-input'),
            style: styles === null || styles === void 0 ? void 0 : styles.input,
            classes: inputClasses,
            styles: inputStyles,
            ref,
            id
        };
        return isLoading ? (React__default.createElement(LoadingRenderer, Object.assign({}, props))) : readOnly ? (React__default.createElement(ReadOnlyRenderer, Object.assign({}, props))) : inputType === 'textField' ? (React__default.createElement(TextField, Object.assign({}, other, commonProps))) : inputType === 'select' ? (React__default.createElement(Select, Object.assign({}, other, commonProps))) : inputType === 'radioChoices' ? (React__default.createElement(RadioChoices, Object.assign({}, other, commonProps))) : inputType === 'multiChoices' ? (React__default.createElement(MultiChoices, Object.assign({}, other, commonProps))) : inputType === 'autoComplete' ? (
        //@ts-ignore
        React__default.createElement(AutoComplete, Object.assign({}, other, commonProps))) : (React__default.createElement(DatePicker, Object.assign({}, other, commonProps)));
    }, [
        readOnly,
        inputType,
        classes === null || classes === void 0 ? void 0 : classes.input,
        id,
        styles === null || styles === void 0 ? void 0 : styles.input,
        ref,
        size,
        emptyValueInReadOnly,
        Object.values(Object.assign({}, other))
    ]);
    const container = useMemo(() => (createInputContainer ? createInputContainer(inputUi) : undefined), [createInputContainer, inputUi]);
    const valuesIsEmpty = (props.value == undefined || props.value === '') &&
        (props.values == undefined || props.values.length === 0);
    if (readOnly &&
        valuesIsEmpty &&
        !isLoading &&
        emptyValueInReadOnly == undefined)
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement(Box, { className: className, style: style, sx: orientation === 'horizontal'
            ? Object.assign({ display: 'flex', flexDirection: 'row', alignItems: 'center', justifyContent: 'space-between', gap: (theme) => theme.spacing(2), '& .AruiInputForm-labelContainer': {
                    margin: 'unset'
                }, '& .AruiInputForm-input': {
                    flexGrow: 1
                } }, sx) : sx },
        labelUi, container !== null && container !== void 0 ? container : inputUi));
});

const FormComponent = styled('form')({});
const useStyles$4 = makeG2STyles()((theme) => ({
    fieldContainer: {
        gap: theme.spacing * 3
    }
}));
const Form = (props) => {
    const { actions, fields, onSubmit, className, onChange, classes, styles, formState, actionsPosition = 'below', actionsStackProps, fieldsStackProps, isLoading = false, readOnly = false } = props, other = __rest(props, ["actions", "fields", "onSubmit", "className", "onChange", "classes", "styles", "formState", "actionsPosition", "actionsStackProps", "fieldsStackProps", "isLoading", "readOnly"]);
    const defaultStyles = useStyles$4();
    const fieldsMemoized = useMemo(() => fields.map((field) => {
        const input = getInput(field, formState, classes, styles, isLoading, readOnly);
        if (field.customDisplay) {
            return field.customDisplay(input);
        }
        return input;
    }), [
        fields,
        formState.values,
        formState.handleChange,
        formState.errors,
        classes === null || classes === void 0 ? void 0 : classes.field,
        styles === null || styles === void 0 ? void 0 : styles.field,
        isLoading,
        readOnly
    ]);
    const actionsDisplay = useMemo(() => {
        if (!actions || actions.length === 0)
            return undefined;
        return (React__default.createElement(Actions, Object.assign({ actions: actions, className: 'AruiForm-actions', style: styles === null || styles === void 0 ? void 0 : styles.actions, classes: {
                button: 'AruiForm-button'
            }, styles: { button: styles === null || styles === void 0 ? void 0 : styles.button }, sx: Object.assign({ marginTop: (theme) => theme.spacing(2) }, actionsStackProps === null || actionsStackProps === void 0 ? void 0 : actionsStackProps.sx) }, actionsStackProps)));
    }, [actions, classes === null || classes === void 0 ? void 0 : classes.button, styles === null || styles === void 0 ? void 0 : styles.button]);
    return (React__default.createElement(FormComponent, Object.assign({ onSubmit: formState.handleSubmit, className: cx('AruiForm-root', className) }, other),
        actionsPosition === 'above' && !isLoading && actionsDisplay,
        React__default.createElement(Stack, Object.assign({}, fieldsStackProps, { className: cx(defaultStyles.classes.fieldContainer, 'AruiForm-fieldsContainer', classes === null || classes === void 0 ? void 0 : classes.fieldsContainer), style: styles === null || styles === void 0 ? void 0 : styles.fieldsContainer }), fieldsMemoized),
        actionsPosition === 'below' && !isLoading && actionsDisplay));
};
const getInput = (field, formState, classes, styles, isLoading, readOnly) => {
    var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0, _1, _2, _3, _4;
    const commonProps = {
        key: field.key,
        id: field.key,
        label: field.label,
        name: field.name,
        error: !!formState.errors[field.name],
        errorMessage: formState.errors[field.name],
        isLoading: isLoading,
        className: cx(classes === null || classes === void 0 ? void 0 : classes.field, 'AruiForm-field', (_a = field.checkBoxProps) === null || _a === void 0 ? void 0 : _a.className, (_b = field.datePickerProps) === null || _b === void 0 ? void 0 : _b.className, (_c = field.selectProps) === null || _c === void 0 ? void 0 : _c.className, (_d = field.autoCompleteProps) === null || _d === void 0 ? void 0 : _d.className, (_e = field.radioChoicesProps) === null || _e === void 0 ? void 0 : _e.className, (_f = field.textFieldProps) === null || _f === void 0 ? void 0 : _f.className),
        style: Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.field), (_g = field.checkBoxProps) === null || _g === void 0 ? void 0 : _g.style), (_h = field.datePickerProps) === null || _h === void 0 ? void 0 : _h.style), (_j = field.selectProps) === null || _j === void 0 ? void 0 : _j.style), (_k = field.autoCompleteProps) === null || _k === void 0 ? void 0 : _k.style), (_l = field.radioChoicesProps) === null || _l === void 0 ? void 0 : _l.style), (_m = field.textFieldProps) === null || _m === void 0 ? void 0 : _m.style)
    };
    switch (field.type) {
        case 'datepicker': {
            const date = new Date(formState.getFieldProps(field.name).value);
            return (React__default.createElement(InputForm, Object.assign({ inputType: 'datePicker', value: !isNaN(date.getTime())
                    ? date
                    : (_o = formState.getFieldProps(field.name).value) !== null && _o !== void 0 ? _o : '', onChangeDate: (date) => {
                    formState.setFieldValue(field.name, date && !isNaN(date.getTime()) ? date : date === null || date === void 0 ? void 0 : date.toString(), false);
                    !!field.onChange && field.onChange(date);
                } }, field.datePickerProps, commonProps, { readOnly: readOnly === true ? readOnly : (_p = field.datePickerProps) === null || _p === void 0 ? void 0 : _p.readOnly })));
        }
        case 'select':
            return ((_q = field.selectProps) === null || _q === void 0 ? void 0 : _q.multiple) === true ? (React__default.createElement(InputForm, Object.assign({ inputType: 'select', values: (_r = formState.getFieldProps(field.name).value) !== null && _r !== void 0 ? _r : [], onChangeValues: (values) => {
                    formState.setFieldValue(field.name, values, false);
                    !!field.onChange && field.onChange(values);
                } }, field.selectProps, commonProps, { readOnly: readOnly === true ? readOnly : (_s = field.selectProps) === null || _s === void 0 ? void 0 : _s.readOnly }))) : (React__default.createElement(InputForm, Object.assign({ inputType: 'select', value: (_t = formState.getFieldProps(field.name).value) !== null && _t !== void 0 ? _t : '', onChangeValue: (value) => {
                    formState.setFieldValue(field.name, value, false);
                    !!field.onChange && field.onChange(value);
                } }, field.selectProps, commonProps, { readOnly: readOnly === true ? readOnly : (_u = field.selectProps) === null || _u === void 0 ? void 0 : _u.readOnly })));
        case 'autoComplete':
            return ((_v = field.autoCompleteProps) === null || _v === void 0 ? void 0 : _v.multiple) === true ? (
            // @ts-ignore
            React__default.createElement(InputForm, Object.assign({ inputType: 'autoComplete', values: (_w = formState.getFieldProps(field.name).value) !== null && _w !== void 0 ? _w : [], onChangeValues: (values) => {
                    formState.setFieldValue(field.name, values, false);
                    !!field.onChange && field.onChange(values);
                } }, field.autoCompleteProps, commonProps, { readOnly: readOnly === true ? readOnly : (_x = field.autoCompleteProps) === null || _x === void 0 ? void 0 : _x.readOnly }))) : (
            // @ts-ignore
            React__default.createElement(InputForm, Object.assign({ inputType: 'autoComplete', value: (_y = formState.getFieldProps(field.name).value) !== null && _y !== void 0 ? _y : null, onChangeValue: (value) => {
                    formState.setFieldValue(field.name, value, false);
                    !!field.onChange && field.onChange(value);
                } }, field.autoCompleteProps, commonProps, { readOnly: readOnly === true ? readOnly : (_z = field.autoCompleteProps) === null || _z === void 0 ? void 0 : _z.readOnly })));
        case 'checkbox':
            return (React__default.createElement(CheckBox, Object.assign({ checked: formState.getFieldProps(field.name).value, onChange: (_, value) => {
                    formState.setFieldValue(field.name, value, false);
                    !!field.onChange && field.onChange(value);
                } }, field.checkBoxProps, commonProps, { disabled: readOnly === true ? readOnly : (_0 = field.checkBoxProps) === null || _0 === void 0 ? void 0 : _0.disabled })));
        case 'radioChoices':
            return (React__default.createElement(InputForm, Object.assign({ inputType: 'radioChoices', value: (_1 = formState.getFieldProps(field.name).value) !== null && _1 !== void 0 ? _1 : '', onChange: (value) => {
                    formState.setFieldValue(field.name, value, false);
                    !!field.onChange && field.onChange(value);
                } }, field.radioChoicesProps, commonProps, { readOnly: readOnly === true ? readOnly : (_2 = field.radioChoicesProps) === null || _2 === void 0 ? void 0 : _2.readOnly })));
    }
    return (React__default.createElement(InputForm, Object.assign({ inputType: 'textField', value: (_3 = formState.getFieldProps(field.name).value) !== null && _3 !== void 0 ? _3 : '', onChange: (value) => {
            formState.setFieldValue(field.name, value, false);
            !!field.onChange && field.onChange(value);
        } }, field.textFieldProps, commonProps, { readOnly: readOnly === true ? readOnly : (_4 = field.textFieldProps) === null || _4 === void 0 ? void 0 : _4.readOnly })));
};

const useForm = (params) => {
    return useFormBase(params);
};
/**
 * the useForm with the minimum informations needed to init the useformik state
 */
const useFormWithPartialFields = (params) => {
    return useFormBase(params);
};
const emptyAction$1 = () => { };
const useFormBase = (params) => {
    const { fields, onSubmit, formikConfig } = params;
    const initialValues = useMemo(() => {
        const obj = {};
        fields.forEach((field) => {
            obj[field.name] = field.defaultValue;
        });
        return obj;
    }, [fields]);
    const validate = useCallback(async (values) => {
        var _a;
        const errors = {};
        for (const field of fields) {
            const error = await ((_a = field.validator) === null || _a === void 0 ? void 0 : _a.call(field, values[field.name], values));
            if (error) {
                errors[field.name] = error;
            }
        }
        return errors;
    }, [fields]);
    const formik = useFormik(Object.assign({ initialValues: initialValues, onSubmit: onSubmit !== null && onSubmit !== void 0 ? onSubmit : emptyAction$1, validate: validate, validateOnBlur: false, validateOnChange: false }, formikConfig));
    const validateField = useCallback(async (fieldName) => {
        const field = fields.find((field) => field.name === fieldName);
        const error = (field === null || field === void 0 ? void 0 : field.validator)
            ? await (field === null || field === void 0 ? void 0 : field.validator(formik.values[fieldName], formik.values))
            : undefined;
        formik.setFieldError(fieldName, error);
        return error;
    }, [fields, formik.values, formik.setFieldError]);
    return Object.assign(Object.assign({}, formik), { validateField: validateField });
};

const dateFnsLocales = {
    fr,
    enUS
};
const useStyles$3 = makeG2STyles()({
    root: {
        position: 'relative',
        width: 'fit-content'
    },
    input: {
        width: '100%',
        '& .MuiInputBase-root': {
            minWidth: '120px',
            paddingRight: '12px'
        }
    },
    inputWithRemove: {
        width: '100%',
        '& .MuiInputBase-root': {
            minWidth: '150px',
            paddingRight: `12px`
        },
        '& .MuiInputBase-input': {
            paddingRight: `20px`
        }
    },
    calendarIcon: {
        width: '17px',
        height: '17px',
        cursor: 'pointer',
        color: 'currentColor',
        stroke: 'currentColor',
        fill: 'none'
    },
    calendarIconDisabled: {
        cursor: 'default'
    },
    clear: {
        right: '30px'
    }
});
const FilterDatePickerBase = (props, ref) => {
    const { value, onChangeDate, onRemove, className, style, id, minDate, maxDate, disabled = false, label = '', color = 'primary', variant = 'filled', textFieldProps, name, classes, styles, InputLabelProps, onClose, onOpen } = props, other = __rest(props, ["value", "onChangeDate", "onRemove", "className", "style", "id", "minDate", "maxDate", "disabled", "label", "color", "variant", "textFieldProps", "name", "classes", "styles", "InputLabelProps", "onClose", "onOpen"]);
    const defaultStyles = useFilterInputStyles();
    const localStyles = useStyles$3();
    const [open, setOpen] = useState(false);
    const { i18n } = useTranslation();
    const colorStyle = useFilterColorStyle({
        color,
        variant
    });
    const onOpenMemoized = useCallback(() => {
        console.log('open');
        setOpen(true);
        onOpen && onOpen();
    }, [onOpen]);
    const onCloseMemoized = useCallback(() => {
        setOpen(false);
        onClose && onClose();
    }, [onClose]);
    const format = useMemo(() => {
        if (i18n.language === 'fr')
            return {
                format: 'dd/MM/yyyy',
                views: ['day', 'month', 'year']
            };
        return {
            format: 'yyyy/MM/dd',
            views: ['year', 'month', 'day']
        };
    }, [i18n.language]);
    const onChange = useCallback((date) => {
        onChangeDate && onChangeDate(date ? new Date(date) : undefined);
    }, [onChangeDate]);
    const getVariantColorClass = useCallback(() => {
        if (variant === 'outlined') {
            switch (color) {
                case 'primary':
                    return defaultStyles.classes.inputOutlinedPrimaryColor;
                case 'secondary':
                    return defaultStyles.classes.inputOutlinedSecondaryColor;
                case 'default':
                    return defaultStyles.classes.inputOutlinedGreyColor;
            }
        }
        switch (color) {
            case 'primary':
                return defaultStyles.classes.inputFilledPrimaryColor;
            case 'secondary':
                return defaultStyles.classes.inputFilledSecondaryColor;
            case 'default':
                return defaultStyles.classes.inputFilledGreyColor;
            default:
                return defaultStyles.classes.inputFilledGreyColor;
        }
    }, [variant, color]);
    const rightIcon = useMemo(() => {
        if (!value)
            return undefined;
        if (onRemove && !disabled)
            return (React__default.createElement(ClearRounded, { onClick: onRemove, className: defaultStyles.cx(defaultStyles.classes.clear, localStyles.classes.clear, 'AruiFilterDatePicker-clearIcon', classes === null || classes === void 0 ? void 0 : classes.clearIcon), style: styles === null || styles === void 0 ? void 0 : styles.clearIcon }));
        return undefined;
    }, [
        value,
        onRemove,
        defaultStyles.classes.clear,
        disabled,
        localStyles.classes.clear,
        classes === null || classes === void 0 ? void 0 : classes.clearIcon,
        styles === null || styles === void 0 ? void 0 : styles.clearIcon
    ]);
    const InputProps = Object.assign({ endAdornment: (React__default.createElement(InputAdornment, { style: variant === 'filled' ? colorStyle : undefined, component: 'div', position: 'end' },
            React__default.createElement(Calendar, { onClick: !disabled ? onOpenMemoized : undefined, className: defaultStyles.cx(localStyles.classes.calendarIcon, disabled && localStyles.classes.calendarIconDisabled, 'AruiFilterDatePicker-calendarIcon', classes === null || classes === void 0 ? void 0 : classes.calendarIcon), style: styles === null || styles === void 0 ? void 0 : styles.calendarIcon }))), onClick: onOpenMemoized, style: variant === 'filled'
            ? Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.input), colorStyle) : styles === null || styles === void 0 ? void 0 : styles.input, className: defaultStyles.cx('AruiDatePicker-input', classes === null || classes === void 0 ? void 0 : classes.input) }, textFieldProps === null || textFieldProps === void 0 ? void 0 : textFieldProps.InputProps);
    return (React__default.createElement(LocalizationProvider, { dateAdapter: AdapterDateFns, adapterLocale: dateFnsLocales[i18n.language === 'en' ? 'enUS' : 'fr'] },
        React__default.createElement("div", { className: defaultStyles.cx(localStyles.classes.root, 'AruiFilterDatePicker-root', className), style: variant === 'filled' ? Object.assign(Object.assign({}, style), colorStyle) : style },
            React__default.createElement(MobileDatePicker, Object.assign({ ref: ref, label: variant === 'outlined' ? label : undefined, open: open, onOpen: onOpen, onClose: onCloseMemoized, format: format.format, views: format.views, minDate: minDate, maxDate: maxDate, slotProps: {
                    actionBar: {
                        actions: ['cancel', 'clear', 'accept']
                    },
                    textField: Object.assign(Object.assign({}, textFieldProps), { id,
                        name,
                        disabled, placeholder: variant === 'filled' ? label : undefined, color: color !== 'default' ? color : undefined, className: defaultStyles.cx(defaultStyles.classes.input, variant !== 'outlined' &&
                            defaultStyles.classes.inputWithoutLabel, rightIcon
                            ? localStyles.classes.inputWithRemove
                            : localStyles.classes.input, getVariantColorClass(), 'AruiFilterDatePicker-datePicker', classes === null || classes === void 0 ? void 0 : classes.textField), style: styles === null || styles === void 0 ? void 0 : styles.textField, variant: 'outlined', InputProps: InputProps, InputLabelProps: Object.assign(Object.assign({}, InputLabelProps), { className: defaultStyles.cx(defaultStyles.classes.label, 'AruiFilterDatePicker-label', classes === null || classes === void 0 ? void 0 : classes.label), style: styles === null || styles === void 0 ? void 0 : styles.label }) })
                }, slots: {
                    actionBar: CustomActionBar
                }, disabled: disabled, value: value ? value : null, onChange: onChange }, other)),
            rightIcon)));
};
const FilterDatePicker = forwardRef(FilterDatePickerBase);

const useStyles$2 = makeG2STyles()((theme) => ({
    input: {
        '& .MuiInputLabel-outlined': {
            maxWidth: 'calc(100% - 50px)'
        },
        '& .MuiInputLabel-outlined.MuiInputLabel-shrink': {
            maxWidth: 'unset'
        }
    },
    root: {
        '& .MuiFilledInput-input': {
            margin: '0px 5px'
        },
        '& .MuiSelect-icon': {
            right: '12px',
            color: 'inherit'
        }
    },
    clear: {
        position: 'absolute',
        right: '32px',
        top: '50%',
        width: '21px',
        height: '21px',
        marginTop: '-10px',
        cursor: 'pointer',
        color: '#323338'
    },
    list: {
        padding: '0px',
        '& .MuiMenuItem-root': {
            padding: '2px',
            paddingRight: `${theme.spacing}px`
        }
    },
    selectPaddingWithClear: {
        '& .MuiSelect-select': {
            paddingRight: '52px !important'
        }
    },
    selectPadding: {
        '& .MuiSelect-select': {
            paddingRight: '40px !important',
            margin: '0px'
        }
    },
    menu: {
        marginTop: '5px'
    },
    chip: {
        width: '17px',
        minWidth: '17px',
        height: '17px',
        display: 'flex',
        justifyContent: 'center',
        cursor: 'pointer',
        marginLeft: '7px',
        alignItems: 'center',
        background: 'white',
        border: 'none',
        '& .MuiChip-label': {
            padding: 0,
            fontSize: '12px',
            fontWeight: 600
        }
    },
    label: {
        cursor: 'pointer',
        lineHeight: 'unset'
    }
}));
const FilterSelect = React__default.forwardRef((props, ref) => {
    var _a;
    const { value = '', values = [], onChangeValue, onChangeValues, name, options = [], className, placeholder = '', style, id, onRemove, disabled = false, classes, styles, label, multiple = false, color = 'primary', variant = 'filled', displaySelected = false, onClose, startAdornment } = props, other = __rest(props, ["value", "values", "onChangeValue", "onChangeValues", "name", "options", "className", "placeholder", "style", "id", "onRemove", "disabled", "classes", "styles", "label", "multiple", "color", "variant", "displaySelected", "onClose", "startAdornment"]);
    const defaultStyles = useFilterInputStyles();
    const localStyles = useStyles$2();
    const colorStyle = useFilterColorStyle({
        color,
        variant
    });
    const onChangeMemoized = useCallback((event) => {
        const eventValue = event.target.value;
        if (Array.isArray(eventValue)) {
            onChangeValues &&
                onChangeValues(extractNumberOrBooleanFromString(eventValue));
        }
        else {
            onChangeValue &&
                onChangeValue(extractNumberOrBooleanFromString(eventValue));
        }
    }, [onChangeValue, onChangeValues]);
    const optionsMap = useMemo(() => new Map(options.map((el) => [el.key, el])), [options]);
    const currentOption = useMemo(() => (value ? optionsMap.get(value) : undefined), [value, optionsMap]);
    const renderValue = useCallback((selected) => {
        var _a;
        const count = Array.isArray(selected)
            ? selected.length
            : selected === ''
                ? 0
                : 1;
        return (React__default.createElement(Box, { display: 'flex', justifyContent: 'space-between', alignItems: 'center' },
            React__default.createElement(InputLabel, { className: defaultStyles.cx(defaultStyles.classes.label, localStyles.classes.label, 'AruiFilterSelect-label', classes === null || classes === void 0 ? void 0 : classes.label), style: Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.label), colorStyle) }, displaySelected && !Array.isArray(selected) && !!selected
                ? (_a = optionsMap.get(selected)) === null || _a === void 0 ? void 0 : _a.label
                : label),
            !(displaySelected && !Array.isArray(selected)) && (React__default.createElement(Chip$1, { className: defaultStyles.cx(localStyles.classes.chip, 'AruiFilterSelect-chip', classes === null || classes === void 0 ? void 0 : classes.chip), label: count, variant: 'outlined', color: color, style: styles === null || styles === void 0 ? void 0 : styles.chip, sx: {
                    visibility: count <= 0 ? 'hidden' : 'visible'
                } }))));
    }, [
        placeholder,
        variant,
        color,
        colorStyle,
        label,
        classes === null || classes === void 0 ? void 0 : classes.label,
        classes === null || classes === void 0 ? void 0 : classes.chip,
        styles === null || styles === void 0 ? void 0 : styles.label,
        styles === null || styles === void 0 ? void 0 : styles.chip,
        displaySelected,
        optionsMap
    ]);
    const optionsMemoized = useMemo(() => {
        return options.map((option) => (
        //@ts-ignore
        React__default.createElement(MenuItem, { "data-value": option.key.toString(), className: defaultStyles.cx('AruiFilterSelect-option', classes === null || classes === void 0 ? void 0 : classes.option), style: styles === null || styles === void 0 ? void 0 : styles.option, key: option.key.toString(), value: option.key },
            React__default.createElement(CheckBox, { "data-value": option.key.toString(), checked: values.indexOf(option.key) > -1 || value === option.key }),
            option.icon && (React__default.createElement(ListItemIcon, { sx: {
                    minWidth: '0 !important'
                } }, option.icon)),
            React__default.createElement(ListItemText, { "data-value": option.key.toString(), primary: option.label, primaryTypographyProps: { variant: 'body2' } }))));
    }, [options, values, value, classes === null || classes === void 0 ? void 0 : classes.option, styles === null || styles === void 0 ? void 0 : styles.option]);
    const inputProp = useMemo(() => {
        return {
            name: name,
            className: defaultStyles.cx('AruiFilterSelect-select', classes === null || classes === void 0 ? void 0 : classes.input),
            style: styles === null || styles === void 0 ? void 0 : styles.input,
            id: id
        };
    }, [name, onRemove, value, classes === null || classes === void 0 ? void 0 : classes.input, styles === null || styles === void 0 ? void 0 : styles.input, id]);
    const getVariantColorClass = () => {
        if (variant === 'outlined') {
            switch (color) {
                case 'primary':
                    return defaultStyles.classes.inputOutlinedPrimaryColor;
                case 'secondary':
                    return defaultStyles.classes.inputOutlinedSecondaryColor;
                case 'default':
                    return defaultStyles.classes.inputOutlinedGreyColor;
            }
        }
        switch (color) {
            case 'primary':
                return defaultStyles.classes.inputFilledPrimaryColor;
            case 'secondary':
                return defaultStyles.classes.inputFilledSecondaryColor;
            case 'default':
                return defaultStyles.classes.inputFilledGreyColor;
            default:
                return defaultStyles.classes.inputFilledGreyColor;
        }
    };
    const onCloseMemoized = useCallback((event) => {
        //@ts-ignore
        const valueClicked = event.currentTarget.dataset.value;
        onRemove &&
            value &&
            valueClicked &&
            value.toString() === valueClicked.toString() &&
            onRemove();
        onClose && onClose(event);
    }, [value, onRemove, onClose]);
    return (React__default.createElement(FormControl, { variant: 'outlined', color: color !== 'default' ? color : undefined, className: defaultStyles.cx(defaultStyles.classes.input, localStyles.classes.input, defaultStyles.classes.inputWithoutLabel, getVariantColorClass(), 'AruiFilterSelect-root', className), style: style },
        React__default.createElement(Select$1, Object.assign({}, other, { ref: ref, onClose: onCloseMemoized, className: defaultStyles.cx(localStyles.classes.root, localStyles.classes.selectPadding, 'AruiFilterSelect-select', classes === null || classes === void 0 ? void 0 : classes.select), value: multiple ? values : value, multiple: multiple, onChange: onChangeMemoized, IconComponent: KeyboardArrowDownRounded, inputProps: inputProp, renderValue: renderValue, displayEmpty: true, startAdornment: (currentOption === null || currentOption === void 0 ? void 0 : currentOption.icon) || startAdornment ? (React__default.createElement(Box, { sx: {
                    display: 'flex',
                    marginRight: '-6px'
                } }, (_a = currentOption === null || currentOption === void 0 ? void 0 : currentOption.icon) !== null && _a !== void 0 ? _a : startAdornment)) : undefined, MenuProps: {
                anchorOrigin: {
                    vertical: 'bottom',
                    horizontal: 'center'
                },
                transformOrigin: {
                    vertical: 'top',
                    horizontal: 'center'
                },
                classes: { list: localStyles.classes.list },
                className: defaultStyles.cx(localStyles.classes.menu, 'AruiFilterSelect-menu', classes === null || classes === void 0 ? void 0 : classes.menu),
                style: styles === null || styles === void 0 ? void 0 : styles.menu
            }, style: variant === 'filled'
                ? Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.select), colorStyle) : styles === null || styles === void 0 ? void 0 : styles.select, disabled: disabled }), optionsMemoized)));
});

const useStyles$1 = makeG2STyles()({
    root: {
        position: 'relative',
        width: 'fit-content'
    },
    searchIcon: {
        width: '17px',
        height: '17px',
        cursor: 'pointer',
        color: 'currentColor',
        fill: 'currentColor'
    },
    input: {
        width: '100%'
    },
    withIconEndOnRemove: {
        '& .MuiInputBase-input': {
            paddingRight: '22px !important'
        }
    },
    inputWithEndAbornment: {
        paddingRight: '20px'
    },
    clearWithEndAbornment: {
        right: 33
    }
});
const FilterTextField = React__default.forwardRef((props, ref) => {
    const { className, error = false, label = '', id = '', onChange, style, textFieldType = 'text', defaultValue, value, disabled = false, inputIcon, onRemove, classes, styles, iconPosition = 'start', onSearch, InputProps, color = 'primary', variant = 'filled', inputProps, InputLabelProps, placeholder } = props, other = __rest(props, ["className", "error", "label", "id", "onChange", "style", "textFieldType", "defaultValue", "value", "disabled", "inputIcon", "onRemove", "classes", "styles", "iconPosition", "onSearch", "InputProps", "color", "variant", "inputProps", "InputLabelProps", "placeholder"]);
    const defaultStyles = useFilterInputStyles();
    const localStyles = useStyles$1();
    const colorStyle = useFilterColorStyle({
        color,
        variant
    });
    const onChangeMemoized = useCallback((e) => onChange && onChange(e.target.value), [onChange]);
    const upHandler = useCallback((event) => {
        if (event.key === 'Enter') {
            event.currentTarget.blur();
            onSearch && onSearch();
        }
    }, [onSearch]);
    const inputAdornment = useMemo(() => {
        const abordementStyles = variant === 'filled' ? colorStyle : undefined;
        if (textFieldType === 'search') {
            if (iconPosition === 'start') {
                return {
                    startAdornment: (React__default.createElement(InputAdornment, { style: abordementStyles, component: 'div', position: 'start' },
                        React__default.createElement(SearchIcon, { onClick: onSearch, className: defaultStyles.cx(localStyles.classes.searchIcon, 'AruiTextfield-searchIcon', classes === null || classes === void 0 ? void 0 : classes.searchIcon), style: styles === null || styles === void 0 ? void 0 : styles.searchIcon })))
                };
            }
            else {
                return {
                    endAdornment: (React__default.createElement(InputAdornment, { style: abordementStyles, component: 'div', position: 'end' },
                        React__default.createElement(SearchIcon, { onClick: onSearch, className: defaultStyles.cx(localStyles.classes.searchIcon, 'AruiTextfield-searchIcon', classes === null || classes === void 0 ? void 0 : classes.searchIcon), style: styles === null || styles === void 0 ? void 0 : styles.searchIcon })))
                };
            }
        }
        else {
            if (inputIcon && iconPosition === 'start') {
                return {
                    startAdornment: (React__default.createElement(InputAdornment, { style: abordementStyles, component: 'div', position: 'start' }, inputIcon))
                };
            }
            else if (inputIcon) {
                return {
                    endAdornment: (React__default.createElement(InputAdornment, { style: abordementStyles, component: 'div', position: 'end' }, inputIcon))
                };
            }
            return {};
        }
    }, [
        textFieldType,
        inputIcon,
        iconPosition,
        classes === null || classes === void 0 ? void 0 : classes.searchIcon,
        styles === null || styles === void 0 ? void 0 : styles.searchIcon,
        onSearch,
        colorStyle,
        variant
    ]);
    const rightIcon = useMemo(() => {
        if (!value || value === '')
            return undefined;
        if (onRemove && !disabled)
            return (React__default.createElement(ClearRounded, { onClick: onRemove, className: defaultStyles.cx(defaultStyles.classes.clear, inputAdornment.endAdornment &&
                    localStyles.classes.clearWithEndAbornment, 'AruiTextfield-clearIcon', classes === null || classes === void 0 ? void 0 : classes.clearIcon), style: styles === null || styles === void 0 ? void 0 : styles.clearIcon }));
        return undefined;
    }, [
        value,
        onRemove,
        classes === null || classes === void 0 ? void 0 : classes.clearIcon,
        styles === null || styles === void 0 ? void 0 : styles.clearIcon,
        inputAdornment.endAdornment,
        disabled
    ]);
    const getVariantColorClass = () => {
        if (variant === 'outlined') {
            switch (color) {
                case 'primary':
                    return defaultStyles.classes.inputOutlinedPrimaryColor;
                case 'secondary':
                    return defaultStyles.classes.inputOutlinedSecondaryColor;
                case 'default':
                    return defaultStyles.classes.inputOutlinedGreyColor;
            }
        }
        switch (color) {
            case 'primary':
                return defaultStyles.classes.inputFilledPrimaryColor;
            case 'secondary':
                return defaultStyles.classes.inputFilledSecondaryColor;
            case 'default':
                return defaultStyles.classes.inputFilledGreyColor;
            default:
                return defaultStyles.classes.inputFilledGreyColor;
        }
    };
    return (React__default.createElement("div", { className: defaultStyles.cx(localStyles.classes.root, 'AruiTextfield-root', className), style: variant === 'filled' ? Object.assign(Object.assign({}, style), colorStyle) : style },
        React__default.createElement(TextField$1, Object.assign({}, other, { ref: ref, id: id, label: variant === 'outlined' ? label : undefined, InputLabelProps: Object.assign(Object.assign({}, InputLabelProps), { className: defaultStyles.cx(defaultStyles.classes.label, 'AruiTextfield-label', classes === null || classes === void 0 ? void 0 : classes.label), style: styles === null || styles === void 0 ? void 0 : styles.label }), placeholder: variant === 'filled' ? label : placeholder, variant: 'outlined', color: color !== 'default' ? color : undefined, value: value, onChange: onChangeMemoized, type: textFieldType === 'search' ? 'text' : textFieldType, defaultValue: defaultValue, className: defaultStyles.cx(defaultStyles.classes.input, (variant !== 'outlined' || !label) &&
                defaultStyles.classes.inputWithoutLabel, localStyles.classes.input, onRemove &&
                inputAdornment.endAdornment &&
                textFieldType === 'search' &&
                defaultStyles.classes.inputWithClear, getVariantColorClass(), 'AruiTextfield-Textfield', classes === null || classes === void 0 ? void 0 : classes.textfield), style: styles === null || styles === void 0 ? void 0 : styles.textfield, disabled: disabled, inputProps: Object.assign({ size: '5' }, inputProps), InputProps: Object.assign(Object.assign(Object.assign({}, inputAdornment), { onKeyUp: upHandler, style: variant === 'filled'
                    ? Object.assign(Object.assign({}, styles === null || styles === void 0 ? void 0 : styles.input), colorStyle) : styles === null || styles === void 0 ? void 0 : styles.input, className: defaultStyles.cx(inputAdornment.endAdornment &&
                    onRemove &&
                    localStyles.classes.withIconEndOnRemove, !!onRemove &&
                    !!value &&
                    value !== '' &&
                    !inputAdornment.endAdornment &&
                    localStyles.classes.inputWithEndAbornment, 'AruiTextfield-input', classes === null || classes === void 0 ? void 0 : classes.input) }), InputProps) })),
        rightIcon));
});

const useStyles = makeG2STyles()({
    form: {
        display: 'flex',
        justifyContent: 'flex-end',
        alignItems: 'center'
    },
    actionContainer: {
        display: 'inline-flex',
        '& .AruiFilters-button': {
            padding: '3px'
        }
    }
});
const Filters = (props) => {
    var _a;
    const { actions, fields, onSubmit, className, classes, styles, formState, actionsPosition = 'left', defaultSubmitBehavior = true, actionsStackProps, fieldsStackProps, responsive = false } = props, other = __rest(props, ["actions", "fields", "onSubmit", "className", "classes", "styles", "formState", "actionsPosition", "defaultSubmitBehavior", "actionsStackProps", "fieldsStackProps", "responsive"]);
    const defaultStyles = useStyles();
    const containerSize = useElementSize();
    const contentSize = useElementSize();
    const [renderedContentWidth, setRenderedContentWidth] = useState(undefined);
    useLayoutEffect(() => {
        if (contentSize.width > 0) {
            setRenderedContentWidth(contentSize.width);
        }
    }, [contentSize.width]);
    // const isOverflowing = useMemo(() => {
    //   if (!renderedContentWidth) return false
    //   if (renderedContentWidth > containerSize.width) return true
    //   return false
    // }, [renderedContentWidth, containerSize.width])
    const fieldsMemoized = useMemo(() => fields.map((field, index) => {
        var _a, _b, _c, _d, _e, _f, _g, _h;
        if (field === 'spacer')
            return React__default.createElement(Box, { key: index, sx: { flexGrow: 1 } });
        const commonProps = {
            key: field.key,
            id: field.key,
            label: field.label,
            name: field.name,
            className: cx(classes === null || classes === void 0 ? void 0 : classes.field, 'AruiFilters-field', (_a = field.datePickerProps) === null || _a === void 0 ? void 0 : _a.className, (_b = field.selectProps) === null || _b === void 0 ? void 0 : _b.className, (_c = field.textFieldProps) === null || _c === void 0 ? void 0 : _c.className),
            style: styles === null || styles === void 0 ? void 0 : styles.field
        };
        const textField = (React__default.createElement(FilterTextField, Object.assign({ value: (_d = formState.values[field.name]) !== null && _d !== void 0 ? _d : '', onChange: (value) => formState.setFieldValue(field.name, value, false), onRemove: () => {
                formState.setFieldValue(field.name, '', false);
                defaultSubmitBehavior && formState.submitForm();
            }, textFieldType: 'search', onSearch: () => defaultSubmitBehavior && formState.submitForm() }, field.textFieldProps, commonProps)));
        switch (field.type) {
            case 'textfield':
                return textField;
            case 'datepicker':
                return (React__default.createElement(FilterDatePicker, Object.assign({ value: (_e = formState.values[field.name]) !== null && _e !== void 0 ? _e : '', onChangeDate: (date) => {
                        formState.setFieldValue(field.name, date, false);
                    }, onRemove: () => {
                        formState.setFieldValue(field.name, '', false);
                        defaultSubmitBehavior && formState.submitForm();
                    }, onClose: () => {
                        defaultSubmitBehavior && formState.submitForm();
                    } }, field.datePickerProps, commonProps)));
            case 'select':
                return ((_f = field.selectProps) === null || _f === void 0 ? void 0 : _f.multiple) === true ? (React__default.createElement(FilterSelect, Object.assign({ values: (_g = formState.values[field.name]) !== null && _g !== void 0 ? _g : [], onChangeValues: (values) => formState.setFieldValue(field.name, values, false), onRemove: () => {
                        formState.setFieldValue(field.name, [], false);
                        defaultSubmitBehavior && formState.submitForm();
                    }, onClose: () => defaultSubmitBehavior && formState.submitForm() }, field.selectProps, commonProps))) : (React__default.createElement(FilterSelect, Object.assign({ value: (_h = formState.values[field.name]) !== null && _h !== void 0 ? _h : '', onChangeValue: (value) => {
                        formState.setFieldValue(field.name, value, false);
                        formState.submitForm();
                    }, onRemove: () => {
                        formState.setFieldValue(field.name, '', false);
                        defaultSubmitBehavior && formState.submitForm();
                    }, onClose: () => defaultSubmitBehavior && formState.submitForm() }, field.selectProps, commonProps)));
            default:
                return textField;
        }
    }), [
        fields,
        formState.values,
        formState.handleChange,
        formState.errors,
        classes === null || classes === void 0 ? void 0 : classes.field,
        styles === null || styles === void 0 ? void 0 : styles.field,
        defaultSubmitBehavior
    ]);
    const actionsDisplay = useMemo(() => {
        if (!actions || actions.length === 0)
            return React__default.createElement(React__default.Fragment, null);
        return (React__default.createElement(Actions, { direction: 'row', actions: actions, className: 'AruiFilters-actions', style: styles === null || styles === void 0 ? void 0 : styles.actions, classes: {
                button: 'AruiFilters-button'
            }, styles: { button: styles === null || styles === void 0 ? void 0 : styles.button } }));
    }, [actions, classes === null || classes === void 0 ? void 0 : classes.button, styles === null || styles === void 0 ? void 0 : styles.button]);
    const content = (React__default.createElement(React__default.Fragment, null,
        actionsPosition === 'left' && actionsDisplay,
        React__default.createElement(Stack, Object.assign({ direction: 'row' }, fieldsStackProps, { sx: Object.assign({ display: 'flex', justifyContent: 'flex-end', flexGrow: 1, flexWrap: !responsive ? 'wrap' : 'nowrap', gap: (theme) => theme.spacing(1) }, fieldsStackProps === null || fieldsStackProps === void 0 ? void 0 : fieldsStackProps.sx), className: cx('AruiFilters-fieldsContainer', classes === null || classes === void 0 ? void 0 : classes.fieldsContainer), style: styles === null || styles === void 0 ? void 0 : styles.fieldsContainer }), fieldsMemoized),
        actionsPosition === 'right' && actionsDisplay));
    return (React__default.createElement("form", Object.assign({ ref: containerSize.ref, onSubmit: formState.handleSubmit, className: cx((_a = defaultStyles.classes) === null || _a === void 0 ? void 0 : _a.form, 'AruiFilters-root', className) }, other), !renderedContentWidth ? (React__default.createElement(Box, { ref: contentSize.ref, sx: {
            width: 'fit-content',
            justifyContent: 'flex-end',
            alignItems: 'center',
            visibility: 'hidden',
            display: 'flex'
        } }, content)) : (content)));
};

const useFilters = (params) => {
    return useFiltersBase(params);
};
/**
 * the usefilters with the minimum informations needed to init the useformik state
 */
const useFiltersWithPartialFields = (params) => {
    return useFiltersBase(params);
};
const emptyAction = () => { };
const useFiltersBase = (params) => {
    const { fields, onSubmit, formikConfig } = params;
    const initialValues = useMemo(() => {
        const obj = {};
        fields.forEach((field) => {
            obj[field.name] = field.defaultValue;
        });
        return obj;
    }, []);
    const formik = useFormik(Object.assign({ initialValues: initialValues, onSubmit: onSubmit !== null && onSubmit !== void 0 ? onSubmit : emptyAction }, formikConfig));
    return formik;
};

const retrieveNumber = (value) => {
    const number = Number(value);
    if (!isNaN(number))
        return number;
    return value;
};
const unformatFieldValue = (field, value) => {
    const date = new Date(Number(value));
    switch (field.type) {
        case 'datepicker':
            return date.toString();
        case 'textfield':
            return retrieveNumber(value);
        default:
            return value;
    }
};
const formatFieldValue = (field, value) => {
    switch (field.type) {
        case 'datepicker':
            return Date.parse(value);
        default:
            return value;
    }
};
const useEnhancedFiltersBase = (params) => {
    const { fields, onSubmit, formikConfig, initAdditionalFilters } = params;
    const [searchParams, setSearchParams] = useSearchParams();
    const initialValues = useMemo(() => {
        const obj = {};
        const params = qs.parse(searchParams.toString());
        fields.forEach((field) => {
            obj[field.name] = params[field.name]
                ? unformatFieldValue(field, params[field.name])
                : field.defaultValue;
            delete params[field.name];
        });
        let additionals = {};
        const unformattedParams = {};
        for (const i in params) {
            unformattedParams[i] = retrieveNumber(params[i]);
        }
        additionals = Object.assign(Object.assign({}, initAdditionalFilters), unformattedParams);
        return {
            formValues: obj,
            additionalFilters: additionals,
            allFilters: Object.assign(Object.assign({}, obj), additionals)
        };
    }, []);
    const [submittedFilters, setSubmittedFilters] = useState(initialValues.allFilters);
    const [additionalFilters, setAdditionalFilters] = useState(initialValues.additionalFilters);
    const onSubmitMemoized = useCallback((values, formikHelpers) => {
        onSubmit && onSubmit(values, formikHelpers, additionalFilters);
        const fieldsValues = Object.assign({}, values);
        fields.forEach((field) => {
            fieldsValues[field.name] = fieldsValues[field.name]
                ? formatFieldValue(field, fieldsValues[field.name])
                : undefined;
        });
        const filters = Object.assign(Object.assign({}, fieldsValues), additionalFilters);
        setSearchParams(qs.stringify(filters, {
            addQueryPrefix: true,
            arrayFormat: 'repeat'
        }));
        setSubmittedFilters(filters);
    }, [onSubmit, searchParams, setSearchParams, additionalFilters]);
    const formik = useFormik(Object.assign({ initialValues: initialValues.formValues, onSubmit: onSubmitMemoized }, formikConfig));
    const setAdditionalFiltersMeMoized = useCallback((filters) => {
        setAdditionalFilters(filters);
        formik.submitForm();
    }, [formik.submitForm]);
    return {
        formFilters: formik,
        additionalFilters,
        setAdditionalFilters: setAdditionalFiltersMeMoized,
        submittedFilters
    };
};
const useEnhancedFilters = (params) => {
    return useEnhancedFiltersBase(params);
};
/**
 * the useEnhancedFilters with the minimum informations needed to init the useformik state
 */
const useEnhancedFiltersWithPartialFields = (params) => {
    return useEnhancedFiltersBase(params);
};

const FilterButton = (props) => {
    const { color = 'primary', variant = 'filled', sx, children } = props, other = __rest(props, ["color", "variant", "sx", "children"]);
    const theme = useTheme();
    const colorStyle = useFilterColorStyle({
        color,
        variant
    });
    const colorFinal = useMemo(() => {
        if (variant === 'filled')
            return colorStyle.color;
        return '#353945';
    }, [colorStyle.color, variant, color]);
    const background = useMemo(() => {
        if (variant === 'filled') {
            return color === 'default' ? '#F2F2F2' : theme.colors[color];
        }
        return;
    }, [variant, color, theme]);
    const borderColor = useMemo(() => {
        return color === 'default' ? '#BDBDBD' : theme.colors[color];
    }, [color, theme]);
    return (React__default.createElement(Button, Object.assign({}, other, { sx: {
            '& .MuiButton-startIcon': {
                margin: !children ? 'unset' : ''
            }
        }, style: {
            color: colorFinal,
            background: background,
            borderColor: borderColor,
            borderStyle: 'solid',
            borderWidth: '2px',
            padding: '7px 12px'
        }, variant: variant === 'outlined' ? variant : 'contained', startIcon: React__default.createElement(FilterAltOutlined, { sx: { width: 24, height: 24 } }) }), children));
};

//@ts-ignore
const LazyMarker = lazy(async () => (await import('react-leaflet')).Marker);
const DraggableMarker = (props) => {
    const { draggable = false, onPositionChange, position, map } = props;
    const [diplayInfo, setDiplayInfo] = useState(draggable);
    const [markerRef, setmarkerRef] = useState(null);
    const hasPositionChanged = useRef(false);
    const { t } = useTranslation();
    useEffect(() => {
        setDiplayInfo(draggable);
    }, [draggable]);
    useEffect(() => {
        if (!hasPositionChanged.current && position && map) {
            map.setView(position, 10);
        }
    }, [position, map]);
    const eventHandlers = useMemo(() => ({
        dragend() {
            const marker = markerRef;
            if (marker != null && onPositionChange) {
                onPositionChange(marker.getLatLng(), GeoJSON.parse(marker.getLatLng(), { Point: ['lat', 'lng'] }));
                hasPositionChanged.current = true;
            }
        },
        dragstart() {
            setDiplayInfo(false);
        },
        click() {
            setDiplayInfo(false);
        }
    }), [onPositionChange, markerRef]);
    useEffect(() => {
        if (diplayInfo && !!markerRef) {
            markerRef.bindPopup(t('g2.canDrag')).openPopup();
        }
        else {
            markerRef === null || markerRef === void 0 ? void 0 : markerRef.closePopup();
            markerRef === null || markerRef === void 0 ? void 0 : markerRef.unbindPopup();
        }
    }, [diplayInfo, markerRef]);
    if (!position)
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement(LazyMarker, { draggable: draggable, eventHandlers: eventHandlers, position: position, ref: setmarkerRef }));
};
const DraggableMarkerControl = (props) => {
    const { onPositionChange, position, map, isSm, isFullScreen, readOnly } = props;
    const { t } = useTranslation();
    const onAddMarker = useCallback(() => {
        !!map &&
            onPositionChange &&
            onPositionChange(map.getCenter(), GeoJSON.parse(map.getCenter(), { Point: ['lat', 'lng'] }));
    }, [onPositionChange, map]);
    const onUseMyLocation = useCallback(() => {
        !!map &&
            navigator.geolocation.getCurrentPosition((event) => {
                const position = {
                    lat: event.coords.latitude,
                    lng: event.coords.longitude
                };
                if (onPositionChange) {
                    onPositionChange(position, GeoJSON.parse(position, { Point: ['lat', 'lng'] }));
                    map.flyTo(position, 17, {
                        duration: 3
                    });
                }
            }, undefined, {
                enableHighAccuracy: true,
                timeout: 5000,
                maximumAge: 0
            });
    }, [onPositionChange, map]);
    if (!map || readOnly)
        return React__default.createElement(React__default.Fragment, null);
    return (React__default.createElement(React__default.Fragment, null,
        (!isSm || isFullScreen) && !position && (React__default.createElement(Button, { sx: {
                position: 'absolute',
                bottom: isFullScreen && isSm ? '80px' : '20px',
                right: '5px'
            }, onClick: onAddMarker }, t('g2.addMarker'))),
        isSm && (React__default.createElement(Button, { sx: { marginTop: '24px' }, onClick: onUseMyLocation }, t('g2.useMyPosition')))));
};

var DraggableMarker$1 = /*#__PURE__*/Object.freeze({
  __proto__: null,
  DraggableMarkerControl: DraggableMarkerControl,
  default: DraggableMarker
});

const LazyLeafletMap = lazy(() => import('./LeafletMap-Bmi1RlDe.js'));
const LazyDraggableMarker = lazy(() => Promise.resolve().then(function () { return DraggableMarker$1; }));
const defaultPosition = { center: { lng: 2, lat: 46 }, zoom: 5 };
const Map$1 = (props) => {
    const { children, draggableMarkerPlugin, center, zoom = !center ? defaultPosition.zoom : 17, additionalPlugins, sx, readOnly = false, errorMessage, classes, styles, className, mapProps, tileLayerProps } = props, other = __rest(props, ["children", "draggableMarkerPlugin", "center", "zoom", "additionalPlugins", "sx", "readOnly", "errorMessage", "classes", "styles", "className", "mapProps", "tileLayerProps"]);
    const theme = useTheme$1();
    const isSm = useMediaQuery(theme.breakpoints.down('md'));
    const [isFullScreen, setIsFullScreen] = useState(false);
    const containerRef = useRef(null);
    const { t } = useTranslation();
    const toggleFullScreen = useCallback(() => {
        var _a;
        if (isFullScreen) {
            document.exitFullscreen();
        }
        else {
            (_a = containerRef.current) === null || _a === void 0 ? void 0 : _a.requestFullscreen();
        }
    }, [isFullScreen]);
    const onFullScreenChange = useCallback(() => {
        setIsFullScreen(document.fullscreenElement === containerRef.current);
    }, []);
    useEffect(() => {
        document.addEventListener('fullscreenchange', onFullScreenChange);
        return () => {
            document.removeEventListener('fullscreenchange', onFullScreenChange);
        };
    }, [onFullScreenChange]);
    const [map, setMap] = useState();
    useEffect(() => {
        if (map) {
            if (isSm && !isFullScreen) {
                map.dragging.disable();
            }
            else {
                map.dragging.enable();
            }
        }
    }, [isSm, isFullScreen, map]);
    const plugins = useMemo(() => additionalPlugins === null || additionalPlugins === void 0 ? void 0 : additionalPlugins.map((plugin, index) => {
        const { element } = plugin, otherPluginProps = __rest(plugin, ["element"]);
        const PluginElement = element;
        return (React__default.createElement(PluginElement, Object.assign({}, otherPluginProps, { key: index, isMobile: isSm, readOnly: readOnly, isFullScreen: isFullScreen, map: map })));
    }), [additionalPlugins, readOnly, isSm, isFullScreen, map]);
    return (React__default.createElement(Stack, Object.assign({ ref: containerRef, sx: Object.assign({ position: 'relative', zIndex: 0, transition: '0.6s' }, sx), className: cx('AruiMap-root', className) }, other),
        React__default.createElement(Suspense, { fallback: React__default.createElement("div", null, "Loading map...") },
            React__default.createElement(LazyLeafletMap, Object.assign({}, mapProps, { 
                //@ts-ignore
                ref: setMap, center: center !== null && center !== void 0 ? center : defaultPosition.center, zoom: zoom, scrollWheelZoom: true, className: cx('AruiMap-map', classes === null || classes === void 0 ? void 0 : classes.map), style: Object.assign({ height: '100%', minHeight: 400, width: '100%', zIndex: 0 }, styles === null || styles === void 0 ? void 0 : styles.map) }),
                React__default.createElement(LazyDraggableMarker, Object.assign({ draggable: (!isSm || isFullScreen) && !readOnly }, draggableMarkerPlugin, { map: map })),
                plugins)),
        children,
        isSm && !isFullScreen && (React__default.createElement(Button, { className: cx('AruiMap-openFullScreenButton', classes === null || classes === void 0 ? void 0 : classes.openFullScreenButton), style: styles === null || styles === void 0 ? void 0 : styles.openFullScreenButton, onClick: toggleFullScreen }, t('g2.openFullScreen'))),
        isFullScreen && (React__default.createElement(IconButton, { className: cx('AruiMap-closeFullScreenIcon', classes === null || classes === void 0 ? void 0 : classes.closeFullScreenIcon), sx: { position: 'absolute', top: '10px', right: '5px' }, style: styles === null || styles === void 0 ? void 0 : styles.closeFullScreenIcon, onClick: toggleFullScreen },
            React__default.createElement(CloseRounded, null))),
        !!draggableMarkerPlugin && (React__default.createElement(DraggableMarkerControl, Object.assign({ isFullScreen: isFullScreen, isSm: isSm }, draggableMarkerPlugin, { map: map, readOnly: readOnly }))),
        !!errorMessage && (React__default.createElement(FormHelperText, { sx: {
                position: 'absolute',
                top: '100%',
                color: 'error.main',
                whiteSpace: 'nowrap',
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                lineHeight: 1.667,
                width: '100%',
                margin: '0',
                marginTop: '3px'
            }, className: cx('AruiMap-errorMessage', classes === null || classes === void 0 ? void 0 : classes.errorMessage), style: styles === null || styles === void 0 ? void 0 : styles.errorMessage }, errorMessage))));
};

const MarkdownStyleContainer = styled(Box, {
    shouldForwardProp: (prop) => prop !== 'titlesTopLevel'
})(({ theme, titlesTopLevel }) => (Object.assign({ '& > :first-child': {
        marginTop: '0px'
    }, '& > :last-child': {
        marginBottom: '0px'
    }, '& ol, ul': {
        paddingInlineStart: '18px'
    }, '& strong': {
        fontWeight: 600
    }, '& li::marker': {
        fontWeight: 600
    }, '& ol li::marker': {
        color: theme.palette.primary.main
    }, '& li': {
        paddingLeft: '4px',
        margin: '8px 0px'
    } }, (titlesTopLevel === 'h1'
    ? {
        '& h1': Object.assign({}, theme.typography.h4),
        '& h2': Object.assign({}, theme.typography.h5),
        '& h3': Object.assign({}, theme.typography.h6),
        '& h4': Object.assign({}, theme.typography.h6),
        '& h5': Object.assign({}, theme.typography.h6),
        '& h6': Object.assign({}, theme.typography.h6)
    }
    : {
        '& h1': Object.assign({}, theme.typography.h4),
        '& h2': Object.assign({}, theme.typography.h4),
        '& h3': Object.assign({}, theme.typography.h4),
        '& h4': Object.assign({}, theme.typography.h4),
        '& h5': Object.assign({}, theme.typography.h5),
        '& h6': Object.assign({}, theme.typography.h6)
    }))));
const MarkdownViewer = (props) => {
    const { markdown, titlesTopLevel } = props, other = __rest(props, ["markdown", "titlesTopLevel"]);
    return (React__default.createElement(MarkdownStyleContainer, Object.assign({}, other, { titlesTopLevel: titlesTopLevel }),
        React__default.createElement(Markdown, { remarkPlugins: [remarkGfm], rehypePlugins: [rehypeRaw] }, markdown)));
};

const IS_BOLD = 0b1;
const IS_ITALIC = 0b10;
const IS_UNDERLINE = 0b1000;
const TglButton = styled(ToggleButton)({
    border: 0,
    color: '#BDBDBD',
    [`&.${toggleButtonGroupClasses.disabled}`]: {
        border: 0
    },
    '&.Mui-selected': {
        background: 'unset',
        color: '#616161'
    }
});
const HistoryActionButton = styled(ToggleButton)({
    border: 0,
    background: 'unset',
    color: '#616161',
    [`&.${toggleButtonGroupClasses.disabled}`]: {
        border: 0,
        color: '#BDBDBD'
    }
});
const Toolbar = (props) => {
    const { titlesTopLevel } = props;
    const [currentFormat] = useCellValues(currentFormat$);
    const applyFormat = usePublisher(applyFormat$);
    const [currentListType] = useCellValues(currentListType$);
    const applyListType = usePublisher(applyListType$);
    const convertSelectionToNode = usePublisher(convertSelectionToNode$);
    const currentBlockType = useCellValue(currentBlockType$);
    const { t } = useTranslation();
    const decorationsDisplay = useMemo(() => [
        {
            value: 'bold',
            isOn: (currentFormat & IS_BOLD) !== 0,
            icon: React__default.createElement(FormatBoldRounded, null)
        },
        {
            value: 'italic',
            isOn: (currentFormat & IS_ITALIC) !== 0,
            icon: React__default.createElement(FormatItalicRounded, null)
        },
        {
            value: 'underline',
            isOn: (currentFormat & IS_UNDERLINE) !== 0,
            icon: React__default.createElement(FormatUnderlinedRounded, null)
        }
    ].map((deco) => {
        return (React__default.createElement(TglButton, { key: deco.value, value: deco.value, "aria-label": deco.value, selected: deco.isOn, onChange: applyFormat.bind(null, deco.value) }, deco.icon));
    }), [currentFormat, applyFormat.bind]);
    const titlesLogic = useMemo(() => titlesTopLevel === 'h1'
        ? [
            {
                value: 'h1',
                selected: currentBlockType === 'h1'
            },
            {
                value: 'h2',
                selected: currentBlockType === 'h2'
            },
            {
                value: 'h3',
                selected: ['h3', 'h4', 'h5', 'h6'].includes(currentBlockType)
            }
        ]
        : [
            {
                value: 'h4',
                selected: ['h1', 'h2', 'h3', 'h4'].includes(currentBlockType)
            },
            {
                value: 'h5',
                selected: currentBlockType === 'h5'
            },
            {
                value: 'h6',
                selected: currentBlockType === 'h6'
            }
        ], [titlesTopLevel, currentBlockType]);
    const titlesDisplay = useMemo(() => titlesLogic.map((logic, index) => {
        const count = index + 1;
        const label = t('g2.title') + ' ' + count;
        return (React__default.createElement(TglButton, { key: count, value: logic.value, "aria-label": label, selected: logic.selected, onChange: (_, value) => convertSelectionToNode(() => $createHeadingNode(value)) },
            React__default.createElement(Typography, { sx: { color: 'currentColor' }, variant: 'body2' }, label)));
    }), [titlesLogic, t, convertSelectionToNode]);
    return (React__default.createElement(Stack, { direction: 'row', gap: 0, width: '100%', alignItems: 'center' },
        React__default.createElement(Stack, { direction: 'row', gap: 0, width: '100%', flexWrap: 'wrap' },
            decorationsDisplay,
            React__default.createElement(Divider, { orientation: 'vertical', flexItem: true, variant: 'middle' }),
            React__default.createElement(TglButton, { value: 'bullet', "aria-label": 'bullet list', selected: currentListType === 'bullet', onChange: (_, value) => applyListType(value) },
                React__default.createElement(FormatListBulletedRounded, null)),
            React__default.createElement(TglButton, { value: 'number', "aria-label": 'numbered list', selected: currentListType === 'number', onChange: (_, value) => applyListType(value) },
                React__default.createElement(FormatListNumberedRounded, null)),
            React__default.createElement(Divider, { orientation: 'vertical', flexItem: true, variant: 'middle' }),
            React__default.createElement(TglButton, { value: 'quote', "aria-label": 'quote', selected: currentBlockType === 'quote', onChange: () => convertSelectionToNode(() => $createQuoteNode()) },
                React__default.createElement(FormatQuoteRounded, null)),
            React__default.createElement(TglButton, { value: 'paragraph', "aria-label": 'paragraph', selected: currentBlockType === 'paragraph', onChange: () => convertSelectionToNode(() => $createParagraphNode()) },
                React__default.createElement(Typography, { sx: { color: 'currentColor' }, variant: 'body2' }, t('g2.text'))),
            titlesDisplay),
        React__default.createElement(Box, { sx: { flexGrow: 1 } }),
        React__default.createElement(UndoRedo, null)));
};
const UndoRedo = () => {
    const [activeEditor] = useCellValues(activeEditor$);
    const [canUndo, setCanUndo] = React__default.useState(false);
    const [canRedo, setCanRedo] = React__default.useState(false);
    React__default.useEffect(() => {
        if (activeEditor) {
            return mergeRegister(activeEditor.registerCommand(CAN_UNDO_COMMAND, (payload) => {
                setCanUndo(payload);
                return false;
            }, COMMAND_PRIORITY_CRITICAL), activeEditor.registerCommand(CAN_REDO_COMMAND, (payload) => {
                setCanRedo(payload);
                return false;
            }, COMMAND_PRIORITY_CRITICAL));
        }
        return;
    }, [activeEditor]);
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(HistoryActionButton, { value: 'undo', "aria-label": 'undo', disabled: !canUndo, selected: false, onChange: () => activeEditor === null || activeEditor === void 0 ? void 0 : activeEditor.dispatchCommand(UNDO_COMMAND, undefined) },
            React__default.createElement(UndoRounded, null)),
        React__default.createElement(HistoryActionButton, { value: 'redo', "aria-label": 'redo', disabled: !canRedo, selected: false, onChange: () => activeEditor === null || activeEditor === void 0 ? void 0 : activeEditor.dispatchCommand(REDO_COMMAND, undefined) },
            React__default.createElement(RedoRounded, null))));
};

function styleInject(css, ref) {
  if ( ref === void 0 ) ref = {};
  var insertAt = ref.insertAt;

  if (typeof document === 'undefined') { return; }

  var head = document.head || document.getElementsByTagName('head')[0];
  var style = document.createElement('style');
  style.type = 'text/css';

  if (insertAt === 'top') {
    if (head.firstChild) {
      head.insertBefore(style, head.firstChild);
    } else {
      head.appendChild(style);
    }
  } else {
    head.appendChild(style);
  }

  if (style.styleSheet) {
    style.styleSheet.cssText = css;
  } else {
    style.appendChild(document.createTextNode(css));
  }
}

var css_248z = ":root, .light, .light-theme {\n  --blue-1: #fbfdff;\n  --blue-2: #f4faff;\n  --blue-3: #e6f4fe;\n  --blue-4: #d5efff;\n  --blue-5: #c2e5ff;\n  --blue-6: #acd8fc;\n  --blue-7: #8ec8f6;\n  --blue-8: #5eb1ef;\n  --blue-9: #0090ff;\n  --blue-10: #0588f0;\n  --blue-11: #0d74ce;\n  --blue-12: #113264;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --blue-1: color(display-p3 0.986 0.992 0.999);\n      --blue-2: color(display-p3 0.96 0.979 0.998);\n      --blue-3: color(display-p3 0.912 0.956 0.991);\n      --blue-4: color(display-p3 0.853 0.932 1);\n      --blue-5: color(display-p3 0.788 0.894 0.998);\n      --blue-6: color(display-p3 0.709 0.843 0.976);\n      --blue-7: color(display-p3 0.606 0.777 0.947);\n      --blue-8: color(display-p3 0.451 0.688 0.917);\n      --blue-9: color(display-p3 0.247 0.556 0.969);\n      --blue-10: color(display-p3 0.234 0.523 0.912);\n      --blue-11: color(display-p3 0.15 0.44 0.84);\n      --blue-12: color(display-p3 0.102 0.193 0.379);\n    }\n  }\n}\n\n.dark, .dark-theme {\n  --blue-1: #0d1520;\n  --blue-2: #111927;\n  --blue-3: #0d2847;\n  --blue-4: #003362;\n  --blue-5: #004074;\n  --blue-6: #104d87;\n  --blue-7: #205d9e;\n  --blue-8: #2870bd;\n  --blue-9: #0090ff;\n  --blue-10: #3b9eff;\n  --blue-11: #70b8ff;\n  --blue-12: #c2e6ff;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    .dark, .dark-theme {\n      --blue-1: color(display-p3 0.057 0.081 0.122);\n      --blue-2: color(display-p3 0.072 0.098 0.147);\n      --blue-3: color(display-p3 0.078 0.154 0.27);\n      --blue-4: color(display-p3 0.033 0.197 0.37);\n      --blue-5: color(display-p3 0.08 0.245 0.441);\n      --blue-6: color(display-p3 0.14 0.298 0.511);\n      --blue-7: color(display-p3 0.195 0.361 0.6);\n      --blue-8: color(display-p3 0.239 0.434 0.72);\n      --blue-9: color(display-p3 0.247 0.556 0.969);\n      --blue-10: color(display-p3 0.344 0.612 0.973);\n      --blue-11: color(display-p3 0.49 0.72 1);\n      --blue-12: color(display-p3 0.788 0.898 0.99);\n    }\n  }\n}\n\n:root, .light, .light-theme {\n  --slate-1: #fcfcfd;\n  --slate-2: #f9f9fb;\n  --slate-3: #f0f0f3;\n  --slate-4: #e8e8ec;\n  --slate-5: #e0e1e6;\n  --slate-6: #d9d9e0;\n  --slate-7: #cdced6;\n  --slate-8: #b9bbc6;\n  --slate-9: #8b8d98;\n  --slate-10: #80838d;\n  --slate-11: #60646c;\n  --slate-12: #1c2024;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --slate-1: color(display-p3 0.988 0.988 0.992);\n      --slate-2: color(display-p3 0.976 0.976 0.984);\n      --slate-3: color(display-p3 0.94 0.941 0.953);\n      --slate-4: color(display-p3 0.908 0.909 0.925);\n      --slate-5: color(display-p3 0.88 0.881 0.901);\n      --slate-6: color(display-p3 0.85 0.852 0.876);\n      --slate-7: color(display-p3 0.805 0.808 0.838);\n      --slate-8: color(display-p3 0.727 0.733 0.773);\n      --slate-9: color(display-p3 0.547 0.553 0.592);\n      --slate-10: color(display-p3 0.503 0.512 0.549);\n      --slate-11: color(display-p3 0.379 0.392 0.421);\n      --slate-12: color(display-p3 0.113 0.125 0.14);\n    }\n  }\n}\n\n.dark, .dark-theme {\n  --slate-1: #111113;\n  --slate-2: #18191b;\n  --slate-3: #212225;\n  --slate-4: #272a2d;\n  --slate-5: #2e3135;\n  --slate-6: #363a3f;\n  --slate-7: #43484e;\n  --slate-8: #5a6169;\n  --slate-9: #696e77;\n  --slate-10: #777b84;\n  --slate-11: #b0b4ba;\n  --slate-12: #edeef0;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    .dark, .dark-theme {\n      --slate-1: color(display-p3 0.067 0.067 0.074);\n      --slate-2: color(display-p3 0.095 0.098 0.105);\n      --slate-3: color(display-p3 0.13 0.135 0.145);\n      --slate-4: color(display-p3 0.156 0.163 0.176);\n      --slate-5: color(display-p3 0.183 0.191 0.206);\n      --slate-6: color(display-p3 0.215 0.226 0.244);\n      --slate-7: color(display-p3 0.265 0.28 0.302);\n      --slate-8: color(display-p3 0.357 0.381 0.409);\n      --slate-9: color(display-p3 0.415 0.431 0.463);\n      --slate-10: color(display-p3 0.469 0.483 0.514);\n      --slate-11: color(display-p3 0.692 0.704 0.728);\n      --slate-12: color(display-p3 0.93 0.933 0.94);\n    }\n  }\n}\n\n:root, .light, .light-theme {\n  --grass-1: #fbfefb;\n  --grass-2: #f5fbf5;\n  --grass-3: #e9f6e9;\n  --grass-4: #daf1db;\n  --grass-5: #c9e8ca;\n  --grass-6: #b2ddb5;\n  --grass-7: #94ce9a;\n  --grass-8: #65ba74;\n  --grass-9: #46a758;\n  --grass-10: #3e9b4f;\n  --grass-11: #2a7e3b;\n  --grass-12: #203c25;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --grass-1: color(display-p3 0.986 0.996 0.985);\n      --grass-2: color(display-p3 0.966 0.983 0.964);\n      --grass-3: color(display-p3 0.923 0.965 0.917);\n      --grass-4: color(display-p3 0.872 0.94 0.865);\n      --grass-5: color(display-p3 0.811 0.908 0.802);\n      --grass-6: color(display-p3 0.733 0.864 0.724);\n      --grass-7: color(display-p3 0.628 0.803 0.622);\n      --grass-8: color(display-p3 0.477 0.72 0.482);\n      --grass-9: color(display-p3 0.38 0.647 0.378);\n      --grass-10: color(display-p3 0.344 0.598 0.342);\n      --grass-11: color(display-p3 0.263 0.488 0.261);\n      --grass-12: color(display-p3 0.151 0.233 0.153);\n    }\n  }\n}\n\n:root, .light, .light-theme {\n  --cyan-1: #fafdfe;\n  --cyan-2: #f2fafb;\n  --cyan-3: #def7f9;\n  --cyan-4: #caf1f6;\n  --cyan-5: #b5e9f0;\n  --cyan-6: #9ddde7;\n  --cyan-7: #7dcedc;\n  --cyan-8: #3db9cf;\n  --cyan-9: #00a2c7;\n  --cyan-10: #0797b9;\n  --cyan-11: #107d98;\n  --cyan-12: #0d3c48;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --cyan-1: color(display-p3 0.982 0.992 0.996);\n      --cyan-2: color(display-p3 0.955 0.981 0.984);\n      --cyan-3: color(display-p3 0.888 0.965 0.975);\n      --cyan-4: color(display-p3 0.821 0.941 0.959);\n      --cyan-5: color(display-p3 0.751 0.907 0.935);\n      --cyan-6: color(display-p3 0.671 0.862 0.9);\n      --cyan-7: color(display-p3 0.564 0.8 0.854);\n      --cyan-8: color(display-p3 0.388 0.715 0.798);\n      --cyan-9: color(display-p3 0.282 0.627 0.765);\n      --cyan-10: color(display-p3 0.264 0.583 0.71);\n      --cyan-11: color(display-p3 0.08 0.48 0.63);\n      --cyan-12: color(display-p3 0.108 0.232 0.277);\n    }\n  }\n}\n\n:root, .light, .light-theme {\n  --amber-1: #fefdfb;\n  --amber-2: #fefbe9;\n  --amber-3: #fff7c2;\n  --amber-4: #ffee9c;\n  --amber-5: #fbe577;\n  --amber-6: #f3d673;\n  --amber-7: #e9c162;\n  --amber-8: #e2a336;\n  --amber-9: #ffc53d;\n  --amber-10: #ffba18;\n  --amber-11: #ab6400;\n  --amber-12: #4f3422;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --amber-1: color(display-p3 0.995 0.992 0.985);\n      --amber-2: color(display-p3 0.994 0.986 0.921);\n      --amber-3: color(display-p3 0.994 0.969 0.782);\n      --amber-4: color(display-p3 0.989 0.937 0.65);\n      --amber-5: color(display-p3 0.97 0.902 0.527);\n      --amber-6: color(display-p3 0.936 0.844 0.506);\n      --amber-7: color(display-p3 0.89 0.762 0.443);\n      --amber-8: color(display-p3 0.85 0.65 0.3);\n      --amber-9: color(display-p3 1 0.77 0.26);\n      --amber-10: color(display-p3 0.959 0.741 0.274);\n      --amber-11: color(display-p3 0.64 0.4 0);\n      --amber-12: color(display-p3 0.294 0.208 0.145);\n    }\n  }\n}\n\n:root, .light, .light-theme {\n  --red-1: #fffcfc;\n  --red-2: #fff7f7;\n  --red-3: #feebec;\n  --red-4: #ffdbdc;\n  --red-5: #ffcdce;\n  --red-6: #fdbdbe;\n  --red-7: #f4a9aa;\n  --red-8: #eb8e90;\n  --red-9: #e5484d;\n  --red-10: #dc3e42;\n  --red-11: #ce2c31;\n  --red-12: #641723;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, .light, .light-theme {\n      --red-1: color(display-p3 0.998 0.989 0.988);\n      --red-2: color(display-p3 0.995 0.971 0.971);\n      --red-3: color(display-p3 0.985 0.925 0.925);\n      --red-4: color(display-p3 0.999 0.866 0.866);\n      --red-5: color(display-p3 0.984 0.812 0.811);\n      --red-6: color(display-p3 0.955 0.751 0.749);\n      --red-7: color(display-p3 0.915 0.675 0.672);\n      --red-8: color(display-p3 0.872 0.575 0.572);\n      --red-9: color(display-p3 0.83 0.329 0.324);\n      --red-10: color(display-p3 0.798 0.294 0.285);\n      --red-11: color(display-p3 0.744 0.234 0.222);\n      --red-12: color(display-p3 0.36 0.115 0.143);\n    }\n  }\n}\n\n/** Code mirror */\n\n.mdxeditor .cm-editor {\n    --sp-font-mono: var(--font-mono);\n    --sp-font-body: var(--font-body);\n    padding: var(--sp-space-4) 0;\n  }\n\n.mdxeditor .cm-scroller {\n    padding: 0 !important;\n  }\n\n.mdxeditor .cm-focused {\n    outline: none;\n  }\n\n.mdxeditor .sp-wrapper {\n    border: 1px solid var(--baseLine);\n    border-radius: var(--radius-medium);\n    overflow: hidden;\n  }\n\n.mdxeditor .sp-layout {\n    border: none;\n  }\n\n.mdxeditor .sp-cm pre {\n      white-space: break-spaces;\n      word-break: break-word;\n      overflow-wrap: anywhere;\n      flex-shrink: 1;\n    }\n\n/** Diff viewer */\n\n.mdxeditor .cm-mergeView .cm-scroller {\n    font-family: var(--font-mono);\n    line-height: 1.3rem;\n    font-size: var(--text-xs);\n  }\n\n/** Diff viewer */\n\n.mdxeditor .cm-sourceView .cm-scroller {\n    font-family: var(--font-mono);\n    line-height: 1.3rem;\n    font-size: var(--text-xs);\n  }\n\n.mdxeditor .cm-gutters {\n    background: transparent;\n    font-size: var(--text-xxs);\n  }\n\n.mdxeditor .cm-activeLine {\n    background: transparent;\n  }\n\n.mdxeditor .cm-tooltip-autocomplete {\n    background: var(--baseBgSubtle);\n  }\n\n.mdxeditor hr.selected[data-lexical-decorator=true] {\n    outline: 2px solid highlight;\n  }\n._editorRoot_1qea1_40 {\n  --accentBase: var(--blue-1);\n  --accentBgSubtle: var(--blue-2);\n  --accentBg: var(--blue-3);\n  --accentBgHover: var(--blue-4);\n  --accentBgActive: var(--blue-5);\n  --accentLine: var(--blue-6);\n  --accentBorder: var(--blue-7);\n  --accentBorderHover: var(--blue-8);\n  --accentSolid: var(--blue-9);\n  --accentSolidHover: var(--blue-10);\n  --accentText: var(--blue-11);\n  --accentTextContrast: var(--blue-12);\n\n  --basePageBg: white;\n  --baseBase: var(--slate-1);\n  --baseBgSubtle: var(--slate-2);\n  --baseBg: var(--slate-3);\n  --baseBgHover: var(--slate-4);\n  --baseBgActive: var(--slate-5);\n  --baseLine: var(--slate-6);\n  --baseBorder: var(--slate-7);\n  --baseBorderHover: var(--slate-8);\n  --baseSolid: var(--slate-9);\n  --baseSolidHover: var(--slate-10);\n  --baseText: var(--slate-11);\n  --baseTextContrast: var(--slate-12);\n\n  --admonitionTipBg: var(--cyan-4);\n  --admonitionTipBorder: var(--cyan-8);\n\n  --admonitionInfoBg: var(--grass-4);\n  --admonitionInfoBorder: var(--grass-8);\n\n  --admonitionCautionBg: var(--amber-4);\n  --admonitionCautionBorder: var(--amber-8);\n\n  --admonitionDangerBg: var(--red-4);\n  --admonitionDangerBorder: var(--red-8);\n\n  --admonitionNoteBg: var(--slate-4);\n  --admonitionNoteBorder: var(--slate-8);\n\n  --error-color: var(--red-10);\n\n  --spacing-0: 0px;\n  --spacing-px: 1px;\n  --spacing-0_5: 0.125rem;\n  --spacing-1: 0.25rem;\n  --spacing-1_5: 0.375rem;\n  --spacing-2: 0.5rem;\n  --spacing-2_5: 0.625rem;\n  --spacing-3: 0.75rem;\n  --spacing-3_5: 0.875rem;\n  --spacing-4: 1rem;\n  --spacing-5: 1.25rem;\n  --spacing-6: 1.5rem;\n  --spacing-7: 1.75rem;\n  --spacing-8: 2rem;\n  --spacing-9: 2.25rem;\n  --spacing-10: 2.5rem;\n  --spacing-11: 2.75rem;\n  --spacing-12: 3rem;\n  --spacing-14: 3.5rem;\n  --spacing-16: 4rem;\n  --spacing-20: 5rem;\n  --spacing-24: 6rem;\n  --spacing-28: 7rem;\n  --spacing-32: 8rem;\n  --spacing-36: 9rem;\n  --spacing-40: 10rem;\n  --spacing-44: 11rem;\n  --spacing-48: 12rem;\n  --spacing-52: 13rem;\n  --spacing-56: 14rem;\n  --spacing-60: 15rem;\n  --spacing-64: 16rem;\n  --spacing-72: 18rem;\n  --spacing-80: 20rem;\n  --spacing-96: 24rem;\n\n  --radius-none: 0px;\n  --radius-small: var(--spacing-0_5);\n  --radius-base: var(--spacing-1);\n  --radius-medium: var(--spacing-1_5);\n  --radius-large: var(--spacing-2);\n  --radius-extra-large: var(--spacing-3);\n  --radius-full: 9999px;\n\n  --font-mono: ui-monospace, SFMono-Regular, Menlo, Monaco, Consolas, \"Liberation Mono\", \"Courier New\", monospace;\n  --font-body: system-ui, -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, Oxygen, Ubuntu, Cantarell, 'Open Sans', 'Helvetica Neue', sans-serif;\n\n  --text-base: 1rem;\n  --text-sm: 0.875rem;\n  --text-xs: 0.75rem;\n  --text-xxs: 0.6rem;\n\n  font-family: var(--font-body);\n  color: var(--baseText);\n}\n\n._editorWrapper_1qea1_141 {}\n\n._nestedListItem_1qea1_143 {\n  list-style: none;\n}\n\n._toolbarRoot_1qea1_147 {\n  /* border: var(--spacing-px) solid var(--baseBorder); */\n  z-index: 1;\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-1);\n  border-radius: var(--radius-medium);\n  padding: var(--spacing-1_5);\n  align-items: center;\n  overflow-x: auto;\n  position: sticky;\n  top: 0;\n  background-color: var(--baseBg);\n  width: inherit;\n}\n\n._toolbarRoot_1qea1_147 div[role=separator] {\n    margin: var(--spacing-2) var(--spacing-1);\n    border-left: 1px solid var(--baseBorder);\n    border-right: 1px solid var(--baseBase);\n    height: var(--spacing-4);\n  }\n\n._readOnlyToolbarRoot_1qea1_170 {\n  pointer-events: none;\n  background: var(--baseBase);\n}\n\n._readOnlyToolbarRoot_1qea1_170>div {\n    opacity: 0.5;\n  }\n\n._toolbarModeSwitch_1qea1_179 {\n  opacity: 1 !important;\n  margin-left: auto;\n  align-self: stretch;\n  align-items: stretch;\n  display: flex;\n  border: 1px solid var(--baseBg);\n  border-radius: var(--radius-medium);\n  font-size: var(--text-xs);\n}\n\n._toolbarModeSwitch_1qea1_179 ._toolbarToggleItem_1qea1_189 {\n    padding-inline-end: var(--spacing-4);\n    padding-inline-start: var(--spacing-4);\n  }\n\n._toolbarModeSwitch_1qea1_179 ._toolbarToggleItem_1qea1_189:active,\n    ._toolbarModeSwitch_1qea1_179 ._toolbarToggleItem_1qea1_189[data-state=on] {\n      background-color: var(--baseBorder);\n    }\n\n._toolbarGroupOfGroups_1qea1_200 {\n  display: flex;\n  margin: 0 var(--spacing-1);\n}\n\n._toolbarToggleSingleGroup_1qea1_205:first-of-type ._toolbarToggleItem_1qea1_189:only-child,\n._toolbarToggleSingleGroup_1qea1_205:only-child ._toolbarToggleItem_1qea1_189:first-child,\n._toolbarModeSwitch_1qea1_179 ._toolbarToggleItem_1qea1_189:first-child {\n  border-top-left-radius: var(--radius-base);\n  border-bottom-left-radius: var(--radius-base);\n}\n\n._toolbarToggleSingleGroup_1qea1_205:last-of-type ._toolbarToggleItem_1qea1_189:only-child,\n._toolbarToggleSingleGroup_1qea1_205:only-child ._toolbarToggleItem_1qea1_189:last-child,\n._toolbarModeSwitch_1qea1_179 ._toolbarToggleItem_1qea1_189:last-child {\n  border-top-right-radius: var(--radius-base);\n  border-bottom-right-radius: var(--radius-base);\n}\n\n._toolbarToggleItem_1qea1_189,\n._toolbarButton_1qea1_220 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  padding: var(--spacing-1);\n}\n\n._toolbarToggleItem_1qea1_189 svg, ._toolbarButton_1qea1_220 svg {\n    display: block;\n  }\n\n@media (hover: hover) {\n    ._toolbarToggleItem_1qea1_189:hover, ._toolbarButton_1qea1_220:hover {\n      background-color: var(--baseBgActive);\n    }\n  }\n\n._toolbarToggleItem_1qea1_189:active svg, ._toolbarButton_1qea1_220:active svg {\n    transform: translate(1px, 1px);\n  }\n\n._toolbarToggleItem_1qea1_189[data-state=on],\n  ._toolbarButton_1qea1_220[data-state=on],\n  ._toolbarToggleItem_1qea1_189:active,\n  ._toolbarButton_1qea1_220:active {\n    color: var(--baseTextContrast);\n    background-color: var(--baseBgActive);\n  }\n\n._toolbarToggleItem_1qea1_189[data-disabled], ._toolbarButton_1qea1_220[data-disabled] {\n    pointer-events: none;\n    color: var(--baseBorderHover);\n  }\n\n._toolbarButton_1qea1_220 {\n  border-radius: var(--radius-base);\n}\n\n._activeToolbarButton_1qea1_254 {\n  color: var(--accentText);\n}\n\n._toolbarToggleSingleGroup_1qea1_205 {\n  white-space: nowrap;\n}\n\n._toolbarNodeKindSelectContainer_1qea1_262,\n._toolbarButtonDropdownContainer_1qea1_263,\n._toolbarCodeBlockLanguageSelectContent_1qea1_264,\n._selectContainer_1qea1_265 {\n  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));\n  z-index: 3;\n  width: var(--spacing-36);\n  border-bottom-left-radius: var(--radius-base);\n  border-bottom-right-radius: var(--radius-base);\n  background-color: var(--basePageBg);\n  font-size: var(--text-sm);\n}\n\n._toolbarButtonDropdownContainer_1qea1_263 {\n  border-top-right-radius: var(--radius-base);\n}\n\n._toolbarButtonDropdownContainer_1qea1_263 ._selectItem_1qea1_278:first-child {\n    border-top-right-radius: var(--radius-base);\n  }\n\n._toolbarNodeKindSelectTrigger_1qea1_283,\n._toolbarButtonSelectTrigger_1qea1_284,\n._selectTrigger_1qea1_285 {\n  border: 0;\n  background-color: transparent;\n  display: flex;\n  color: inherit;\n  align-items: center;\n  width: var(--spacing-36);\n  padding: var(--spacing-1) var(--spacing-2);\n  border-radius: var(--radius-medium);\n  white-space: nowrap;\n  flex-wrap: nowrap;\n  font-size: var(--text-sm);\n  background-color: var(--basePageBg);\n  margin: 0 var(--spacing-1);\n}\n\n._toolbarNodeKindSelectTrigger_1qea1_283[data-state=open], ._toolbarButtonSelectTrigger_1qea1_284[data-state=open], ._selectTrigger_1qea1_285[data-state=open] {\n    filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));\n    border-bottom-right-radius: var(--radius-none);\n    border-bottom-left-radius: var(--radius-none);\n  }\n\n._selectTrigger_1qea1_285[data-placeholder]>span:first-child {\n  color: var(--baseBorderHover);\n}\n\n/** used in the sandpack */\n._toolbarButtonSelectTrigger_1qea1_284 {\n  width: auto;\n  padding-inline-start: var(--spacing-2);\n  padding-inline-end: var(--spacing-1);\n  padding-block: var(--spacing-0_5);\n}\n\n._toolbarCodeBlockLanguageSelectTrigger_1qea1_319,\n._toolbarCodeBlockLanguageSelectContent_1qea1_264 {\n  width: var(--spacing-48);\n}\n\n._toolbarNodeKindSelectItem_1qea1_324,\n._selectItem_1qea1_278 {\n  cursor: default;\n  display: flex;\n  padding: var(--spacing-2);\n}\n\n._toolbarNodeKindSelectItem_1qea1_324[data-highlighted], ._selectItem_1qea1_278[data-highlighted] {\n    background-color: var(--baseBg);\n  }\n\n._toolbarNodeKindSelectItem_1qea1_324[data-state=checked], ._selectItem_1qea1_278[data-state=checked] {\n    color: var(--baseTextContrast);\n    background-color: var(--baseBg);\n  }\n\n._toolbarNodeKindSelectItem_1qea1_324[data-highlighted], ._selectItem_1qea1_278[data-highlighted] {\n    outline: none;\n  }\n\n._toolbarNodeKindSelectItem_1qea1_324:last-child, ._selectItem_1qea1_278:last-child {\n    border-bottom-left-radius: var(--radius-base);\n    border-bottom-right-radius: var(--radius-base);\n  }\n\n._toolbarNodeKindSelectDropdownArrow_1qea1_349,\n._selectDropdownArrow_1qea1_350 {\n  margin-left: auto;\n  display: flex;\n  align-items: center;\n}\n\n._contentEditable_1qea1_356 {\n  box-sizing: border-box;\n  width: 100%;\n  color: var(--baseTextContrast);\n\n  padding: var(--spacing-3);\n}\n\n._contentEditable_1qea1_356:focus {\n    outline: none;\n  }\n\n._codeMirrorWrapper_1qea1_368 {\n  margin-bottom: var(--spacing-5);\n  border: 1px solid var(--baseLine);\n  border-radius: var(--radius-medium);\n  overflow: hidden;\n  padding: 0.8rem;\n}\n\n._frontmatterWrapper_1qea1_376 {\n  border-radius: var(--radius-medium);\n  padding: var(--spacing-3);\n  background-color: var(--baseBgSubtle);\n}\n\n._frontmatterWrapper_1qea1_376[data-expanded=true] {\n    margin-bottom: var(--spacing-10);\n  }\n\n._frontmatterToggleButton_1qea1_386 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-1);\n  font-size: var(--text-sm);\n}\n\n._propertyPanelTitle_1qea1_394 {\n  font-size: var(--text-xs);\n  font-weight: 400;\n  margin: 0;\n  padding-top: var(--spacing-2);\n  padding-left: var(--spacing-2);\n}\n\n._propertyEditorTable_1qea1_402 {\n  table-layout: fixed;\n  border-spacing: var(--spacing-2);\n}\n\n._propertyEditorTable_1qea1_402 th {\n    text-align: left;\n    font-size: var(--text-sm);\n    padding: var(--spacing-2) var(--spacing-3);\n  }\n\n._propertyEditorTable_1qea1_402 col:nth-child(1) {\n    width: 30%;\n  }\n\n._propertyEditorTable_1qea1_402 col:nth-child(2) {\n    width: 70%;\n  }\n\n._propertyEditorTable_1qea1_402 td:last-child ._iconButton_1qea1_420 {\n    margin-left: var(--spacing-4);\n    margin-right: var(--spacing-4);\n  }\n\n._propertyEditorTable_1qea1_402 ._readOnlyColumnCell_1qea1_425 {\n    padding-left: 0;\n  }\n\n._propertyEditorLabelCell_1qea1_430 {\n  font-weight: 400;\n}\n\n._readOnlyColumnCell_1qea1_425 {\n  padding-left: 0;\n}\n\n._buttonsFooter_1qea1_438 {\n  display: flex;\n  justify-content: flex-end;\n  gap: var(--spacing-2);\n}\n\n._propertyEditorInput_1qea1_444 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  width: 100%;\n  padding: var(--spacing-2) var(--spacing-3);\n  border-radius: var(--radius-base);\n  border: 1px solid var(--baseBorder);\n  background-color: var(--baseBase);\n  font-size: var(--text-sm);\n}\n\n._iconButton_1qea1_420 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  color: var(--baseText);\n}\n\n@media (hover: hover) {\n    ._iconButton_1qea1_420:hover {\n      color: var(--accentText);\n    }\n  }\n\n._iconButton_1qea1_420:disabled,\n  ._iconButton_1qea1_420:disabled:hover {\n    color: var(--baseLine);\n  }\n\n._primaryButton_1qea1_470,\n._secondaryButton_1qea1_471 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  padding: var(--spacing-2) var(--spacing-3);\n  border: 1px solid var(--accentBorder);\n  background-color: var(--accentSolidHover);\n  color: var(--baseBase);\n  font-size: var(--text-xs);\n  border-radius: var(--radius-medium);\n}\n\n._primaryButton_1qea1_470:disabled, ._secondaryButton_1qea1_471:disabled {\n    background: var(--accentLine);\n    border-color: var(--accentBg);\n  }\n\n._smallButton_1qea1_486 {\n  font-size: var(--text-xs);\n  padding: var(--spacing-1) var(--spacing-2);\n  border-radius: var(--radius-base);\n}\n\n._secondaryButton_1qea1_471 {\n  border: 1px solid var(--baseBorder);\n  background-color: var(--baseSolidHover);\n  color: var(--baseBase);\n}\n\n._dialogForm_1qea1_498 {\n  display: flex;\n  flex-direction: row;\n  gap: var(--spacing-2);\n}\n\n._linkDialogEditForm_1qea1_504 {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n  gap: var(--spacing-2);\n  padding: 0;\n}\n\n._linkDialogInputContainer_1qea1_512 {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n._linkDialogInputWrapper_1qea1_518 {\n  display: flex;\n  align-items: center;\n  background-color: var(--baseBase);\n\n  border-radius: var(--radius-base);\n  border: 1px solid var(--baseBorder);\n}\n\n._linkDialogInputWrapper_1qea1_518[data-visible-dropdown=true] {\n    border-bottom-left-radius: var(--radius-none);\n    border-bottom-right-radius: var(--radius-none);\n    border-bottom-width: 0;\n  }\n\n._linkDialogInputWrapper_1qea1_518>button {\n    border: 0;\n    background-color: transparent;\n    font-size: inherit;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    all: unset;\n    box-sizing: border-box;\n    cursor: default;\n    padding-right: var(--spacing-2);\n  }\n\n._linkDialogInput_1qea1_512,\n._dialogInput_1qea1_539 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  width: 20rem;\n  padding: var(--spacing-2) var(--spacing-3);\n  font-size: var(--text-sm);\n}\n\n._linkDialogInput_1qea1_512::-moz-placeholder, ._dialogInput_1qea1_539::-moz-placeholder {\n    color: var(--baseBorder);\n  }\n\n._linkDialogInput_1qea1_512::placeholder, ._dialogInput_1qea1_539::placeholder {\n    color: var(--baseBorder);\n  }\n\n._linkDialogAnchor_1qea1_550 {\n  position: fixed;\n  background-color: highlight;\n  z-index: -1;\n}\n\n._linkDialogAnchor_1qea1_550[data-visible=true] {\n    visibility: visible;\n  }\n\n._linkDialogAnchor_1qea1_550[data-visible=false] {\n    visibility: hidden;\n  }\n\n._linkDialogPopoverContent_1qea1_564,\n._tableColumnEditorPopoverContent_1qea1_565,\n._dialogContent_1qea1_566 {\n  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0_5);\n  border-radius: var(--radius-medium);\n  border: 1px solid var(--baseBg);\n  background-color: var(--basePageBg);\n  padding: var(--spacing-1) var(--spacing-2);\n  font-size: var(--text-sm);\n}\n\n._largeDialogContent_1qea1_578 {\n  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));\n  gap: var(--spacing-0_5);\n  border-radius: var(--radius-medium);\n  border: 1px solid var(--baseBorder);\n  background-color: var(--baseBgSubtle);\n  padding: var(--spacing-4);\n  font-size: var(--text-sm);\n}\n\n._dialogTitle_1qea1_588 {\n  font-size: var(--text-base);\n  font-weight: 600;\n  padding-left: var(--spacing-2);\n}\n\n._dialogCloseButton_1qea1_594 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  position: absolute;\n  top: 10px;\n  right: 10px;\n}\n\n._popoverContent_1qea1_601 {\n  filter: drop-shadow(0 2px 2px rgb(0 0 0 / 0.20));\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-0_5);\n  border-radius: var(--radius-medium);\n  background-color: var(--baseBgSubtle);\n  padding: var(--spacing-2) var(--spacing-2);\n  font-size: var(--text-sm);\n  z-index: 1;\n}\n\n._popoverArrow_1qea1_613 {\n  fill: var(--basePageBg);\n}\n\n._linkDialogPreviewAnchor_1qea1_617 {\n  margin-right: var(--spacing-3);\n  display: flex;\n  align-items: flex-start;\n  color: var(--accentText);\n  text-decoration: none;\n\n  border: 1px solid transparent;\n}\n\n._linkDialogPreviewAnchor_1qea1_617 svg {\n    width: var(--spacing-5);\n    height: var(--spacing-5);\n    margin-left: var(--spacing-2);\n  }\n\n._linkDialogPreviewAnchor_1qea1_617 span {\n    max-width: 14rem;\n    overflow-x: hidden;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n  }\n\n._tooltipTrigger_1qea1_640 {\n  align-self: center;\n}\n\n._tooltipContent_1qea1_644 {\n  z-index: 2;\n  position: relative;\n  border-radius: var(--radius-medium);\n  padding: var(--spacing-1) var(--spacing-2);\n  font-size: var(--text-xs);\n  background-color: var(--baseText);\n  color: var(--baseBase);\n}\n\n._tooltipContent_1qea1_644 svg {\n    fill: var(--baseText);\n  }\n\n._actionButton_1qea1_658 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  padding: var(--spacing-1_5);\n  padding: var(--spacing-1) var(--spacing-1);\n  border-radius: var(--radius-medium);\n}\n\n._actionButton_1qea1_658 svg {\n    display: block;\n  }\n\n@media (hover: hover) {\n    ._actionButton_1qea1_658:hover {\n      background-color: var(--baseBgHover);\n    }\n  }\n\n._actionButton_1qea1_658:active svg {\n    transform: translate(1px, 1px);\n  }\n\n._actionButton_1qea1_658[data-state=on],\n  ._actionButton_1qea1_658:active {\n    background-color: var(--baseBgHover);\n    color: var(--baseTextContrast);\n  }\n\n._primaryActionButton_1qea1_664 {\n  background-color: var(--accentSolid);\n  color: var(--baseBase);\n}\n\n@media (hover: hover) {\n    ._primaryActionButton_1qea1_664:hover {\n      background-color: var(--accentSolidHover);\n      color: var(--baseBase);\n    }\n  }\n\n._tableEditor_1qea1_676 {\n  table-layout: fixed;\n  width: 100%;\n  height: 100%;\n  border-spacing: 0;\n  border-collapse: collapse;\n}\n\n._tableEditor_1qea1_676 thead>tr>th {\n    text-align: right;\n  }\n\n._tableEditor_1qea1_676>tbody>tr>td:not(._toolCell_1qea1_687),\n  ._tableEditor_1qea1_676>tbody>tr>th:not(._toolCell_1qea1_687):not(:last-of-type) {\n    border: 1px solid var(--baseBgActive);\n    padding: var(--spacing-1) var(--spacing-2);\n    white-space: normal;\n  }\n\n:is(._tableEditor_1qea1_676>tbody>tr>td:not(._toolCell_1qea1_687),._tableEditor_1qea1_676>tbody>tr>th:not(._toolCell_1qea1_687):not(:last-of-type))>div {\n      outline: none;\n    }\n\n:is(._tableEditor_1qea1_676>tbody>tr>td:not(._toolCell_1qea1_687),._tableEditor_1qea1_676>tbody>tr>th:not(._toolCell_1qea1_687):not(:last-of-type))>div>p {\n        margin: 0;\n      }\n\n[data-active=true]:is(._tableEditor_1qea1_676>tbody>tr>td:not(._toolCell_1qea1_687),._tableEditor_1qea1_676>tbody>tr>th:not(._toolCell_1qea1_687):not(:last-of-type)) {\n      outline: solid 1px var(--baseSolid);\n    }\n\n._tableEditor_1qea1_676 ._tableColumnEditorTrigger_1qea1_706,\n  ._tableEditor_1qea1_676 ._tableRowEditorTrigger_1qea1_707,\n  ._tableEditor_1qea1_676 ._addRowButton_1qea1_708,\n  ._tableEditor_1qea1_676 ._addColumnButton_1qea1_709,\n  ._tableEditor_1qea1_676 ._iconButton_1qea1_420 {\n    opacity: .15;\n  }\n\n@media (hover: hover) {\n\n      ._tableEditor_1qea1_676:hover ._tableColumnEditorTrigger_1qea1_706,\n      ._tableEditor_1qea1_676:hover ._tableRowEditorTrigger_1qea1_707,\n      ._tableEditor_1qea1_676:hover ._addRowButton_1qea1_708,\n      ._tableEditor_1qea1_676:hover ._addColumnButton_1qea1_709,\n      ._tableEditor_1qea1_676:hover ._iconButton_1qea1_420 {\n        opacity: 0.3;\n      }\n\n        ._tableEditor_1qea1_676:hover ._tableColumnEditorTrigger_1qea1_706:hover, ._tableEditor_1qea1_676:hover ._tableRowEditorTrigger_1qea1_707:hover, ._tableEditor_1qea1_676:hover ._addRowButton_1qea1_708:hover, ._tableEditor_1qea1_676:hover ._addColumnButton_1qea1_709:hover, ._tableEditor_1qea1_676:hover ._iconButton_1qea1_420:hover {\n          opacity: 1;\n        }\n  }\n\n._toolCell_1qea1_687 {\n  text-align: right;\n}\n\n._toolCell_1qea1_687 button {\n    margin: auto;\n    display: block;\n  }\n\n._tableColumnEditorTrigger_1qea1_706 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  padding: var(--spacing-1_5);\n  padding: var(--spacing-1);\n  border-radius: var(--radius-full);\n  opacity: 0.2;\n}\n\n._tableColumnEditorTrigger_1qea1_706 svg {\n    display: block;\n  }\n\n@media (hover: hover) {\n    ._tableColumnEditorTrigger_1qea1_706:hover {\n      background-color: var(--baseBgHover);\n    }\n  }\n\n._tableColumnEditorTrigger_1qea1_706:active svg {\n    transform: translate(1px, 1px);\n  }\n\n._tableColumnEditorTrigger_1qea1_706[data-state=on],\n  ._tableColumnEditorTrigger_1qea1_706:active {\n    background-color: var(--baseBgHover);\n    color: var(--baseTextContrast);\n  }\n\n._tableColumnEditorTrigger_1qea1_706[data-active=true] {\n    opacity: 1 !important;\n  }\n\n._tableColumnEditorToolbar_1qea1_752 {\n  display: flex;\n}\n\n._tableColumnEditorToolbar_1qea1_752>button {\n    border: 0;\n    background-color: transparent;\n    font-size: inherit;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    all: unset;\n    box-sizing: border-box;\n    cursor: default;\n    padding: var(--spacing-1_5);\n  }\n\n._tableColumnEditorToolbar_1qea1_752>button svg {\n    display: block;\n  }\n\n@media (hover: hover) {\n    ._tableColumnEditorToolbar_1qea1_752>button:hover {\n      background-color: var(--baseBgHover);\n    }\n  }\n\n._tableColumnEditorToolbar_1qea1_752>button:active svg {\n    transform: translate(1px, 1px);\n  }\n\n._tableColumnEditorToolbar_1qea1_752>button[data-state=on],\n  ._tableColumnEditorToolbar_1qea1_752>button:active {\n    background-color: var(--baseBgHover);\n    color: var(--baseTextContrast);\n  }\n\n._tableColumnEditorToolbar_1qea1_752 [role=separator] {\n    margin-left: var(--spacing-1);\n    margin-right: var(--spacing-1);\n  }\n\n\n._toggleGroupRoot_1qea1_766 {\n  display: inline-flex;\n}\n\n\n._toggleGroupRoot_1qea1_766 button {\n    border: 0;\n    background-color: transparent;\n    font-size: inherit;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    all: unset;\n    box-sizing: border-box;\n    cursor: default;\n    padding: var(--spacing-1_5);\n  }\n\n\n._toggleGroupRoot_1qea1_766 button svg {\n    display: block;\n  }\n\n\n@media (hover: hover) {\n    ._toggleGroupRoot_1qea1_766 button:hover {\n      background-color: var(--baseBgHover);\n    }\n  }\n\n\n._toggleGroupRoot_1qea1_766 button:active svg {\n    transform: translate(1px, 1px);\n  }\n\n\n._toggleGroupRoot_1qea1_766 button[data-state=on],\n  ._toggleGroupRoot_1qea1_766 button:active {\n    background-color: var(--baseBgHover);\n    color: var(--baseTextContrast);\n  }\n\n\n._toggleGroupRoot_1qea1_766 button:first-child {\n      border-top-left-radius: var(--radius-base);\n      border-bottom-left-radius: var(--radius-base);\n    }\n\n\n._toggleGroupRoot_1qea1_766 button:last-child {\n      border-top-right-radius: var(--radius-base);\n      border-bottom-right-radius: var(--radius-base);\n    }\n\n._tableToolsColumn_1qea1_784 {\n  width: 3rem;\n}\n\n._tableToolsColumn_1qea1_784 button {\n    margin: auto;\n    display: block;\n  }\n\n._leftAlignedCell_1qea1_793 {\n  text-align: left;\n}\n\n._rightAlignedCell_1qea1_797 {\n  text-align: right;\n}\n\n._centeredCell_1qea1_801 {\n  text-align: center;\n}\n\n._addColumnButton_1qea1_709,\n._addRowButton_1qea1_708 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  padding: var(--spacing-1_5);\n  background-color: var(--baseBase);\n\n  display: flex;\n  align-items: center;\n}\n\n._addColumnButton_1qea1_709 svg, ._addRowButton_1qea1_708 svg {\n    display: block;\n  }\n\n@media (hover: hover) {\n    ._addColumnButton_1qea1_709:hover, ._addRowButton_1qea1_708:hover {\n      background-color: var(--baseBgHover);\n    }\n  }\n\n._addColumnButton_1qea1_709:active svg, ._addRowButton_1qea1_708:active svg {\n    transform: translate(1px, 1px);\n  }\n\n._addColumnButton_1qea1_709[data-state=on],\n  ._addRowButton_1qea1_708[data-state=on],\n  ._addColumnButton_1qea1_709:active,\n  ._addRowButton_1qea1_708:active {\n    background-color: var(--baseBgHover);\n    color: var(--baseTextContrast);\n  }\n\n._addColumnButton_1qea1_709 svg, ._addRowButton_1qea1_708 svg {\n    margin: auto;\n  }\n\n._addRowButton_1qea1_708 {\n  width: 100%;\n  margin-top: var(--spacing-px);\n  box-sizing: border-box;\n  border-bottom-right-radius: var(--radius-medium);\n  border-bottom-left-radius: var(--radius-medium);\n}\n\n._addColumnButton_1qea1_709 {\n  margin-left: var(--spacing-px);\n  height: 100%;\n  border-top-right-radius: var(--radius-medium);\n  border-bottom-right-radius: var(--radius-medium);\n}\n\n/** Dialog */\n._dialogOverlay_1qea1_834 {\n  position: fixed;\n  inset: 0;\n  animation: _overlayShow_1qea1_1 150ms cubic-bezier(0.16, 1, 0.3, 1);\n  background-color: var(--baseBase);\n  z-index: 51;\n  opacity: 0.5;\n}\n\n._dialogContent_1qea1_566,\n._largeDialogContent_1qea1_578 {\n  position: fixed;\n  top: 50%;\n  left: 50%;\n  transform: translate(-50%, -50%);\n  animation: _contentShow_1qea1_1 150ms cubic-bezier(0.16, 1, 0.3, 1);\n  z-index: 52;\n}\n\n._dialogContent_1qea1_566:focus,\n._largeDialogContent_1qea1_578:focus {\n  outline: none;\n}\n\n\n@keyframes _overlayShow_1qea1_1 {\n  from {\n    opacity: 0;\n  }\n\n  to {\n    opacity: .5;\n  }\n}\n\n@keyframes _contentShow_1qea1_1 {\n  from {\n    opacity: 0;\n    transform: translate(-50%, -48%) scale(0.96);\n  }\n\n  to {\n    opacity: 1;\n    transform: translate(-50%, -50%) scale(1);\n  }\n}\n\n._focusedImage_1qea1_881 {\n  outline: highlight solid 2px;\n}\n\n._imageWrapper_1qea1_885 {\n  display: inline-block;\n  position: relative;\n}\n\n._imageWrapper_1qea1_885[draggable=true] {\n  cursor: move;\n  /* fallback if grab cursor is unsupported */\n  cursor: grab;\n  cursor: -webkit-grab;\n}\n\n._editImageButton_1qea1_898 {\n  position: absolute;\n  right: var(--spacing-2);\n  top: var(--spacing-2);\n  background: var(--baseBase);\n  border-radius: var(--radius-full);\n}\n\n._editImageButton_1qea1_898 svg {\n    display: block;\n  }\n\n._inlineEditor_1qea1_910 {\n  display: inline-flex;\n  border-radius: var(--radius-medium);\n  padding: var(--spacing-1);\n  gap: var(--spacing-2);\n  align-items: center;\n  background: var(--baseBg);\n}\n\n._blockEditor_1qea1_919 {\n  display: flex;\n  justify-content: stretch;\n  border-radius: var(--radius-medium);\n  padding: var(--spacing-2);\n  gap: var(--spacing-2);\n  align-items: center;\n  background: var(--baseBg);\n}\n\n._blockEditor_1qea1_919 ._nestedEditor_1qea1_928 {\n    flex-grow: 1;\n  }\n\n._nestedEditor_1qea1_928 {\n  background: var(--basePageBg);\n  padding: var(--spacing-1) var(--spacing-2);\n  border-radius: var(--radius-medium);\n}\n\n._nestedEditor_1qea1_928>p {\n    margin: 0;\n  }\n\n._nestedEditor_1qea1_928:focus {\n    outline: none;\n  }\n\n._genericComponentName_1qea1_947 {\n  font-size: var(--text-sm);\n  color: var(--baseText);\n  padding-right: var(--spacing-2);\n}\n\n._diffSourceToggle_1qea1_953 {\n  border-radius: var(--radius-medium);\n  display: flex;\n}\n\n._diffSourceToggle_1qea1_953 ._toolbarToggleItem_1qea1_189 {\n    padding: 0;\n  }\n\n._diffSourceToggle_1qea1_953 ._toolbarToggleItem_1qea1_189>span {\n      display: block;\n      padding: var(--spacing-1) var(--spacing-2);\n    }\n\n._selectWithLabel_1qea1_967 {\n  display: flex;\n  align-items: center;\n  gap: var(--spacing-2);\n  margin-left: var(--spacing-2);\n}\n\n._selectWithLabel_1qea1_967>label {\n    font-size: var(--text-sm);\n  }\n\n._selectWithLabel_1qea1_967 ._selectTrigger_1qea1_285 {\n    border: 1px solid var(--baseBorder);\n  }\n\n._toolbarTitleMode_1qea1_982 {\n  font-size: var(--text-sm);\n  margin-left: var(--spacing-2);\n}\n\n\n._imageControlWrapperResizing_1qea1_988 {\n  touch-action: none;\n}\n\n._imageResizer_1qea1_992 {\n  display: block;\n  width: 7px;\n  height: 7px;\n  position: absolute;\n  background-color: var(--accentText);\n  border: 1px solid var(--baseBg);\n}\n\n._imageResizer_1qea1_992._imageResizerN_1qea1_1001 {\n  top: -6px;\n  left: 48%;\n  cursor: n-resize;\n}\n\n._imageResizer_1qea1_992._imageResizerNe_1qea1_1007 {\n  top: -6px;\n  right: -6px;\n  cursor: ne-resize;\n}\n\n._imageResizer_1qea1_992._imageResizerE_1qea1_1013 {\n  bottom: 48%;\n  right: -6px;\n  cursor: e-resize;\n}\n\n._imageResizer_1qea1_992._imageResizerSe_1qea1_1019 {\n  bottom: -2px;\n  right: -6px;\n  cursor: nwse-resize;\n}\n\n._imageResizer_1qea1_992._imageResizerS_1qea1_1019 {\n  bottom: -2px;\n  left: 48%;\n  cursor: s-resize;\n}\n\n._imageResizer_1qea1_992._imageResizerSw_1qea1_1031 {\n  bottom: -2px;\n  left: -6px;\n  cursor: sw-resize;\n}\n\n._imageResizer_1qea1_992._imageResizerW_1qea1_1037 {\n  bottom: 48%;\n  left: -6px;\n  cursor: w-resize;\n}\n\n._imageResizer_1qea1_992._imageResizerNw_1qea1_1043 {\n  top: -6px;\n  left: -6px;\n  cursor: nw-resize;\n}\n\n._placeholder_1qea1_1049 {\n  color: var(--baseSolid);\n  overflow: hidden;\n  position: absolute;\n  top: 0;\n  padding: var(--spacing-3);\n  text-overflow: ellipsis;\n  -webkit-user-select: none;\n     -moz-user-select: none;\n          user-select: none;\n  white-space: nowrap;\n  display: inline-block;\n  pointer-events: none;\n}\n\n._rootContentEditableWrapper_1qea1_1062 {\n  position: relative;\n}\n\n\n\n._downshiftContainer_1qea1_1068 {\n  display: flex;\n  flex-direction: column;\n  align-items: stretch;\n}\n\n._downshiftInputWrapper_1qea1_1074 {\n  display: flex;\n  align-items: center;\n  background-color: var(--baseBase);\n\n  border-radius: var(--radius-base);\n  border: 1px solid var(--baseBorder);\n}\n\n._downshiftInputWrapper_1qea1_1074[data-visible-dropdown=true] {\n    border-bottom-left-radius: var(--radius-none);\n    border-bottom-right-radius: var(--radius-none);\n    border-bottom-width: 0;\n  }\n\n._downshiftInputWrapper_1qea1_1074>button {\n    border: 0;\n    background-color: transparent;\n    font-size: inherit;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    all: unset;\n    box-sizing: border-box;\n    cursor: default;\n    padding-right: var(--spacing-2);\n  }\n\n._downshiftInput_1qea1_1074 {\n  border: 0;\n  background-color: transparent;\n  font-size: inherit;\n  -webkit-appearance: none;\n     -moz-appearance: none;\n          appearance: none;\n  all: unset;\n  box-sizing: border-box;\n  cursor: default;\n  width: 20rem;\n  padding: var(--spacing-2) var(--spacing-3);\n  font-size: var(--text-sm);\n}\n\n._downshiftInput_1qea1_1074::-moz-placeholder {\n    color: var(--baseBorder);\n  }\n\n._downshiftInput_1qea1_1074::placeholder {\n    color: var(--baseBorder);\n  }\n\n._downshiftAutocompleteContainer_1qea1_1105 {\n  position: relative;\n}\n\n._downshiftAutocompleteContainer_1qea1_1105 ul {\n    all: unset;\n    box-sizing: border-box;\n    position: absolute;\n    font-size: var(--text-sm);\n    width: 100%;\n    display: none;\n    border-bottom-left-radius: var(--radius-medium);\n    border-bottom-right-radius: var(--radius-medium);\n    max-height: var(--spacing-48);\n    overflow-x: hidden;\n    overflow-y: auto;\n    border: 1px solid var(--baseBorder);\n    border-top-width: 0;\n    background-color: var(--baseBase);\n  }\n\n._downshiftAutocompleteContainer_1qea1_1105 ul[data-visible=true] {\n      display: block;\n    }\n\n._downshiftAutocompleteContainer_1qea1_1105 ul li {\n      padding: var(--spacing-2) var(--spacing-3);\n      white-space: nowrap;\n      margin-bottom: var(--spacing-1);\n      overflow-x: hidden;\n      text-overflow: ellipsis;\n    }\n\n._downshiftAutocompleteContainer_1qea1_1105 ul li[data-selected=true] {\n        background-color: var(--baseBgSubtle);\n      }\n\n._downshiftAutocompleteContainer_1qea1_1105 ul li[data-highlighted=true] {\n        background-color: var(--baseBgHover);\n      }\n\n._downshiftAutocompleteContainer_1qea1_1105 ul li:last-of-type {\n        border-bottom-left-radius: var(--radius-medium);\n        border-bottom-right-radius: var(--radius-medium);\n      }\n\n._textInput_1qea1_1151 {\n  all: unset;\n  border-radius: var(--radius-base);\n  border: 1px solid var(--baseBorder);\n  background-color: var(--baseBase);\n  padding: var(--spacing-2) var(--spacing-3);\n}\n\nform._multiFieldForm_1qea1_1159 {\n  display: flex;\n  flex-direction: column;\n  padding: var(--spacing-2);\n  gap: var(--spacing-2);\n}\n\nform._multiFieldForm_1qea1_1159 ._formField_1qea1_1165 {\n    display: flex;\n    flex-direction: column;\n    gap: var(--spacing-2);\n  }\n\nform._multiFieldForm_1qea1_1159 ._formField_1qea1_1165 label {\n      font-size: var(--text-xs);\n    }\n\n._markdownParseError_1qea1_1176 {\n  border-radius: var(--radius-base);\n  border: 1px solid var(--error-color);\n  padding: var(--spacing-2);\n  margin-block: var(--spacing-2);\n  color: var(--error-color);\n  font-size: var(--text-xs);\n}\n\n._popupContainer_1qea1_1185 {\n  position: relative;\n  z-index: 1;\n}\n\n._inputSizer_1qea1_1190 {\n  display: inline-grid;\n  vertical-align: baseline;\n  align-items: center;\n  position: relative;\n}\n\n._inputSizer_1qea1_1190::after,\n  ._inputSizer_1qea1_1190 input {\n    width: auto;\n    min-width: 1rem;\n    grid-area: 1 / 2;\n    font: inherit;\n    margin: 0;\n    padding: 0 2px;\n    resize: none;\n    background: none;\n    -webkit-appearance: none;\n       -moz-appearance: none;\n            appearance: none;\n    border: none;\n    color: inherit;\n  }\n\n._inputSizer_1qea1_1190 span {\n    padding: 0.25em;\n  }\n\n._inputSizer_1qea1_1190::after {\n    content: attr(data-value);\n    white-space: pre-wrap;\n  }\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --blue-1: #fbfdff;\n  --blue-2: #f4faff;\n  --blue-3: #e6f4fe;\n  --blue-4: #d5efff;\n  --blue-5: #c2e5ff;\n  --blue-6: #acd8fc;\n  --blue-7: #8ec8f6;\n  --blue-8: #5eb1ef;\n  --blue-9: #0090ff;\n  --blue-10: #0588f0;\n  --blue-11: #0d74ce;\n  --blue-12: #113264;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --blue-1: color(display-p3 0.986 0.992 0.999);\n      --blue-2: color(display-p3 0.96 0.979 0.998);\n      --blue-3: color(display-p3 0.912 0.956 0.991);\n      --blue-4: color(display-p3 0.853 0.932 1);\n      --blue-5: color(display-p3 0.788 0.894 0.998);\n      --blue-6: color(display-p3 0.709 0.843 0.976);\n      --blue-7: color(display-p3 0.606 0.777 0.947);\n      --blue-8: color(display-p3 0.451 0.688 0.917);\n      --blue-9: color(display-p3 0.247 0.556 0.969);\n      --blue-10: color(display-p3 0.234 0.523 0.912);\n      --blue-11: color(display-p3 0.15 0.44 0.84);\n      --blue-12: color(display-p3 0.102 0.193 0.379);\n    }\n  }\n}\n\n._dark_1tncs_1, ._dark-theme_1tncs_1 {\n  --blue-1: #0d1520;\n  --blue-2: #111927;\n  --blue-3: #0d2847;\n  --blue-4: #003362;\n  --blue-5: #004074;\n  --blue-6: #104d87;\n  --blue-7: #205d9e;\n  --blue-8: #2870bd;\n  --blue-9: #0090ff;\n  --blue-10: #3b9eff;\n  --blue-11: #70b8ff;\n  --blue-12: #c2e6ff;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    ._dark_1tncs_1, ._dark-theme_1tncs_1 {\n      --blue-1: color(display-p3 0.057 0.081 0.122);\n      --blue-2: color(display-p3 0.072 0.098 0.147);\n      --blue-3: color(display-p3 0.078 0.154 0.27);\n      --blue-4: color(display-p3 0.033 0.197 0.37);\n      --blue-5: color(display-p3 0.08 0.245 0.441);\n      --blue-6: color(display-p3 0.14 0.298 0.511);\n      --blue-7: color(display-p3 0.195 0.361 0.6);\n      --blue-8: color(display-p3 0.239 0.434 0.72);\n      --blue-9: color(display-p3 0.247 0.556 0.969);\n      --blue-10: color(display-p3 0.344 0.612 0.973);\n      --blue-11: color(display-p3 0.49 0.72 1);\n      --blue-12: color(display-p3 0.788 0.898 0.99);\n    }\n  }\n}\n\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --slate-1: #fcfcfd;\n  --slate-2: #f9f9fb;\n  --slate-3: #f0f0f3;\n  --slate-4: #e8e8ec;\n  --slate-5: #e0e1e6;\n  --slate-6: #d9d9e0;\n  --slate-7: #cdced6;\n  --slate-8: #b9bbc6;\n  --slate-9: #8b8d98;\n  --slate-10: #80838d;\n  --slate-11: #60646c;\n  --slate-12: #1c2024;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --slate-1: color(display-p3 0.988 0.988 0.992);\n      --slate-2: color(display-p3 0.976 0.976 0.984);\n      --slate-3: color(display-p3 0.94 0.941 0.953);\n      --slate-4: color(display-p3 0.908 0.909 0.925);\n      --slate-5: color(display-p3 0.88 0.881 0.901);\n      --slate-6: color(display-p3 0.85 0.852 0.876);\n      --slate-7: color(display-p3 0.805 0.808 0.838);\n      --slate-8: color(display-p3 0.727 0.733 0.773);\n      --slate-9: color(display-p3 0.547 0.553 0.592);\n      --slate-10: color(display-p3 0.503 0.512 0.549);\n      --slate-11: color(display-p3 0.379 0.392 0.421);\n      --slate-12: color(display-p3 0.113 0.125 0.14);\n    }\n  }\n}\n\n._dark_1tncs_1, ._dark-theme_1tncs_1 {\n  --slate-1: #111113;\n  --slate-2: #18191b;\n  --slate-3: #212225;\n  --slate-4: #272a2d;\n  --slate-5: #2e3135;\n  --slate-6: #363a3f;\n  --slate-7: #43484e;\n  --slate-8: #5a6169;\n  --slate-9: #696e77;\n  --slate-10: #777b84;\n  --slate-11: #b0b4ba;\n  --slate-12: #edeef0;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    ._dark_1tncs_1, ._dark-theme_1tncs_1 {\n      --slate-1: color(display-p3 0.067 0.067 0.074);\n      --slate-2: color(display-p3 0.095 0.098 0.105);\n      --slate-3: color(display-p3 0.13 0.135 0.145);\n      --slate-4: color(display-p3 0.156 0.163 0.176);\n      --slate-5: color(display-p3 0.183 0.191 0.206);\n      --slate-6: color(display-p3 0.215 0.226 0.244);\n      --slate-7: color(display-p3 0.265 0.28 0.302);\n      --slate-8: color(display-p3 0.357 0.381 0.409);\n      --slate-9: color(display-p3 0.415 0.431 0.463);\n      --slate-10: color(display-p3 0.469 0.483 0.514);\n      --slate-11: color(display-p3 0.692 0.704 0.728);\n      --slate-12: color(display-p3 0.93 0.933 0.94);\n    }\n  }\n}\n\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --grass-1: #fbfefb;\n  --grass-2: #f5fbf5;\n  --grass-3: #e9f6e9;\n  --grass-4: #daf1db;\n  --grass-5: #c9e8ca;\n  --grass-6: #b2ddb5;\n  --grass-7: #94ce9a;\n  --grass-8: #65ba74;\n  --grass-9: #46a758;\n  --grass-10: #3e9b4f;\n  --grass-11: #2a7e3b;\n  --grass-12: #203c25;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --grass-1: color(display-p3 0.986 0.996 0.985);\n      --grass-2: color(display-p3 0.966 0.983 0.964);\n      --grass-3: color(display-p3 0.923 0.965 0.917);\n      --grass-4: color(display-p3 0.872 0.94 0.865);\n      --grass-5: color(display-p3 0.811 0.908 0.802);\n      --grass-6: color(display-p3 0.733 0.864 0.724);\n      --grass-7: color(display-p3 0.628 0.803 0.622);\n      --grass-8: color(display-p3 0.477 0.72 0.482);\n      --grass-9: color(display-p3 0.38 0.647 0.378);\n      --grass-10: color(display-p3 0.344 0.598 0.342);\n      --grass-11: color(display-p3 0.263 0.488 0.261);\n      --grass-12: color(display-p3 0.151 0.233 0.153);\n    }\n  }\n}\n\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --cyan-1: #fafdfe;\n  --cyan-2: #f2fafb;\n  --cyan-3: #def7f9;\n  --cyan-4: #caf1f6;\n  --cyan-5: #b5e9f0;\n  --cyan-6: #9ddde7;\n  --cyan-7: #7dcedc;\n  --cyan-8: #3db9cf;\n  --cyan-9: #00a2c7;\n  --cyan-10: #0797b9;\n  --cyan-11: #107d98;\n  --cyan-12: #0d3c48;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --cyan-1: color(display-p3 0.982 0.992 0.996);\n      --cyan-2: color(display-p3 0.955 0.981 0.984);\n      --cyan-3: color(display-p3 0.888 0.965 0.975);\n      --cyan-4: color(display-p3 0.821 0.941 0.959);\n      --cyan-5: color(display-p3 0.751 0.907 0.935);\n      --cyan-6: color(display-p3 0.671 0.862 0.9);\n      --cyan-7: color(display-p3 0.564 0.8 0.854);\n      --cyan-8: color(display-p3 0.388 0.715 0.798);\n      --cyan-9: color(display-p3 0.282 0.627 0.765);\n      --cyan-10: color(display-p3 0.264 0.583 0.71);\n      --cyan-11: color(display-p3 0.08 0.48 0.63);\n      --cyan-12: color(display-p3 0.108 0.232 0.277);\n    }\n  }\n}\n\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --amber-1: #fefdfb;\n  --amber-2: #fefbe9;\n  --amber-3: #fff7c2;\n  --amber-4: #ffee9c;\n  --amber-5: #fbe577;\n  --amber-6: #f3d673;\n  --amber-7: #e9c162;\n  --amber-8: #e2a336;\n  --amber-9: #ffc53d;\n  --amber-10: #ffba18;\n  --amber-11: #ab6400;\n  --amber-12: #4f3422;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --amber-1: color(display-p3 0.995 0.992 0.985);\n      --amber-2: color(display-p3 0.994 0.986 0.921);\n      --amber-3: color(display-p3 0.994 0.969 0.782);\n      --amber-4: color(display-p3 0.989 0.937 0.65);\n      --amber-5: color(display-p3 0.97 0.902 0.527);\n      --amber-6: color(display-p3 0.936 0.844 0.506);\n      --amber-7: color(display-p3 0.89 0.762 0.443);\n      --amber-8: color(display-p3 0.85 0.65 0.3);\n      --amber-9: color(display-p3 1 0.77 0.26);\n      --amber-10: color(display-p3 0.959 0.741 0.274);\n      --amber-11: color(display-p3 0.64 0.4 0);\n      --amber-12: color(display-p3 0.294 0.208 0.145);\n    }\n  }\n}\n\n:root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n  --red-1: #fffcfc;\n  --red-2: #fff7f7;\n  --red-3: #feebec;\n  --red-4: #ffdbdc;\n  --red-5: #ffcdce;\n  --red-6: #fdbdbe;\n  --red-7: #f4a9aa;\n  --red-8: #eb8e90;\n  --red-9: #e5484d;\n  --red-10: #dc3e42;\n  --red-11: #ce2c31;\n  --red-12: #641723;\n}\n\n@supports (color: color(display-p3 1 1 1)) {\n  @media (color-gamut: p3) {\n    :root, ._light_1tncs_1, ._light-theme_1tncs_1 {\n      --red-1: color(display-p3 0.998 0.989 0.988);\n      --red-2: color(display-p3 0.995 0.971 0.971);\n      --red-3: color(display-p3 0.985 0.925 0.925);\n      --red-4: color(display-p3 0.999 0.866 0.866);\n      --red-5: color(display-p3 0.984 0.812 0.811);\n      --red-6: color(display-p3 0.955 0.751 0.749);\n      --red-7: color(display-p3 0.915 0.675 0.672);\n      --red-8: color(display-p3 0.872 0.575 0.572);\n      --red-9: color(display-p3 0.83 0.329 0.324);\n      --red-10: color(display-p3 0.798 0.294 0.285);\n      --red-11: color(display-p3 0.744 0.234 0.222);\n      --red-12: color(display-p3 0.36 0.115 0.143);\n    }\n  }\n}\n\n._bold_1tncs_10 {\n  font-weight: bold;\n}\n\n._italic_1tncs_14 {\n  font-style: italic;\n}\n\n._underline_1tncs_18 {\n  text-decoration: underline;\n}\n\n._bold_1tncs_10 {\n  font-weight: 700;\n}\n\n._italic_1tncs_14 {\n  font-style: italic;\n}\n\n._underline_1tncs_18 {\n  text-decoration: underline\n}\n\n._strikethrough_1tncs_34 {\n  text-decoration: line-through\n}\n\n._underlineStrikethrough_1tncs_38 {\n  text-decoration: underline line-through\n}\n\n._subscript_1tncs_42 {\n  font-size: .8em;\n  vertical-align: sub !important\n}\n\n._superscript_1tncs_47 {\n  font-size: .8em;\n  vertical-align: super\n}\n\n._code_1tncs_52 {\n  background-color: var(--baseBg);\n  padding: 1px .25rem;\n  font-family: var(--font-mono);\n  font-size: 94%\n}\n\n._nestedListItem_1tncs_59 {\n  list-style: none;\n  list-style-type: none;\n}\n\n._nestedListItem_1tncs_59:before,\n._nestedListItem_1tncs_59:after {\n  display: none;\n}\n\n._listitem_1tncs_69 {\n  margin: var(--spacing-2) 0;\n}\n\n._listItemChecked_1tncs_73,\n._listItemUnchecked_1tncs_74 {\n  position: relative;\n  margin-left: 0;\n  margin-right: 0;\n  margin-inline-start: -1rem;\n  padding-left: var(--spacing-6);\n  padding-right: var(--spacing-6);\n  list-style-type: none;\n  outline: none;\n}\n\n._listItemChecked_1tncs_73 {\n  text-decoration: line-through;\n}\n\n._listItemUnchecked_1tncs_74:before,\n._listItemChecked_1tncs_73:before {\n  content: '';\n  width: var(--spacing-4);\n  height: var(--spacing-4);\n  top: 0;\n  left: 0;\n  cursor: pointer;\n  display: block;\n  background-size: cover;\n  position: absolute;\n}\n\n._listItemUnchecked_1tncs_74[dir='rtl']:before,\n._listItemChecked_1tncs_73[dir='rtl']:before {\n  left: auto;\n  right: 0;\n}\n\n._listItemUnchecked_1tncs_74:focus:before,\n._listItemChecked_1tncs_73:focus:before {\n  box-shadow: 0 0 0 2px var(--accentBgActive);\n  border-radius: var(--radius-small);\n}\n\n._listItemUnchecked_1tncs_74:before {\n  border: 1px solid var(--baseBorder);\n  border-radius: var(--radius-small);\n}\n\n._listItemChecked_1tncs_73:before {\n  border: 1px solid var(--accentBorder);\n  border-radius: var(--radius-small);\n  background-color: var(--accentSolid);\n  background-repeat: no-repeat;\n}\n\n._listItemChecked_1tncs_73:after {\n  content: '';\n  cursor: pointer;\n  border-color: var(--baseBase);\n  border-style: solid;\n  position: absolute;\n  display: block;\n  top: var(--spacing-0_5);\n  width: var(--spacing-1);\n  left: var(--spacing-1_5);\n  right: var(--spacing-1_5);\n  height: var(--spacing-2);\n  transform: rotate(45deg);\n  border-width: 0 var(--spacing-0_5) var(--spacing-0_5) 0;\n}\n\n._nestedListItem_1tncs_59 {\n  list-style-type: none;\n}\n\n._nestedListItem_1tncs_59:before,\n._nestedListItem_1tncs_59:after {\n  display: none;\n}\n\n._admonitionDanger_1tncs_151,\n._admonitionInfo_1tncs_152,\n._admonitionNote_1tncs_153,\n._admonitionTip_1tncs_154,\n._admonitionCaution_1tncs_155 {\n  padding: var(--spacing-2);\n  margin-top: var(--spacing-2);\n  margin-bottom: var(--spacing-2);\n  border-left: 3px solid var(--admonitionBorder);\n  background-color: var(--admonitionBg);\n}\n\n._admonitionInfo_1tncs_152 {\n  --admonitionBorder: var(--admonitionInfoBorder);\n  --admonitionBg: var(--admonitionInfoBg);\n}\n\n._admonitionTip_1tncs_154 {\n  --admonitionBorder: var(--admonitionTipBorder);\n  --admonitionBg: var(--admonitionTipBg);\n}\n\n._admonitionCaution_1tncs_155 {\n  --admonitionBorder: var(--admonitionCautionBorder);\n  --admonitionBg: var(--admonitionCautionBg);\n}\n\n._admonitionDanger_1tncs_151 {\n  --admonitionBorder: var(--admonitionDangerBorder);\n  --admonitionBg: var(--admonitionDangerBg);\n}\n\n._admonitionNote_1tncs_153 {\n  --admonitionBorder: var(--admonitionNoteBorder);\n  --admonitionBg: var(--admonitionNoteBg);\n}\n\n._mdxExpression_1tncs_188 {\n  font-family: var(--font-mono);\n  font-size: 84%;\n  color: var(--accentText);\n}\n\n._mdxExpression_1tncs_188 input:focus-visible {\n    outline: none;\n  }\n";
styleInject(css_248z);

const MarkdownEditor = (props) => {
    const { titlesTopLevel, styleContainerProps } = props;
    const ref = useRef(null);
    useDidUpdate(() => { var _a; return (_a = ref.current) === null || _a === void 0 ? void 0 : _a.setMarkdown(props.markdown); }, [props.markdown]);
    return (React__default.createElement(MarkdownStyleContainer, Object.assign({}, styleContainerProps, { titlesTopLevel: titlesTopLevel, sx: Object.assign({ '& .markdownEditor': {
                '--font-body': 'unset',
                '--font-mono': 'unset',
                '--baseBg': 'transparent'
            }, '& div[contenteditable="true"]': {
                padding: 0
            } }, styleContainerProps === null || styleContainerProps === void 0 ? void 0 : styleContainerProps.sx) }),
        React__default.createElement(MDXEditor, Object.assign({ className: 'markdownEditor', ref: ref, plugins: [
                headingsPlugin(),
                listsPlugin(),
                quotePlugin(),
                markdownShortcutPlugin(),
                toolbarPlugin({
                    toolbarContents: () => React__default.createElement(Toolbar, { titlesTopLevel: titlesTopLevel })
                })
            ] }, props))));
};

const MarkdownField = (props) => {
    const { markdown, readOnly = false, titlesTopLevel, styleContainerProps } = props, other = __rest(props, ["markdown", "readOnly", "titlesTopLevel", "styleContainerProps"]);
    return readOnly ? (React__default.createElement(MarkdownViewer, Object.assign({}, styleContainerProps, { markdown: markdown, titlesTopLevel: titlesTopLevel }))) : (React__default.createElement(MarkdownEditor, Object.assign({ styleContainerProps: styleContainerProps, markdown: markdown, titlesTopLevel: titlesTopLevel }, other)));
};

export { AutoComplete, CheckBox, DatePicker, FilterButton, FilterDatePicker, FilterSelect, FilterTextField, Filters, Form, InputForm, Map$1 as Map, MarkdownField, MultiChoices, RadioChoices, Select, TextField, useEnhancedFilters, useEnhancedFiltersWithPartialFields, useFilters, useFiltersWithPartialFields, useForm, useFormWithPartialFields };
//# sourceMappingURL=index.es.js.map
